// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { artworkBatchGetMediaId, artworkCreateFromMedia, artworkGetDailyRankingArtworks, artworkGetFollowingNewsArtworks, artworkGetNewestArtworks, artworkGetRecommendArtworks, artworkGetRecommendArtworksVisitor, artworkGetSimilarArtworks, artworkGetTrendingArtworks, attributionCreateClickEvent, attributionUpsertIdentifiers, authResetForgetPassword, authSendForgetPasswordCode, authSignInWithEmail, authSignInWithGoogleToken, bannerList, campaignAdsList, claimClaim, claimGet, claimList, contentSafetyPreferenceGetContentSafetyPreferences, contentSafetyPreferenceUpdateContentSafetyPreference, contestList, contestV2Create, contestV2CreateCheck, contestV2Follow, contestV2GetBySlug, contestV2List, contestV2ListArtwork, contestV2ListArtworkByUser, contestV2ListBanner, contestV2ListCreatedByUser, contestV2ListFollowByUser, contestV2ListWinners, contestV2SubmitArtwork, contestV2Unfollow, creditExchangeCreateTransaction, creditExchangeExternalTokenStatus, creditExchangeRedeemToken, creditExchangeTokenSummary, decorationBatch, decorationGetDecoration, eventPassList, eventPassPurchase, eventPassResetEventPasses, eventPassUserPasses, extraPackageBoostGetByCode, extraPackageBoostListMyBoosts, extraPackageConfirmApple, extraPackageConfirmGoogle, extraPackageConfirmWeb, extraPackageGet, extraPackageList, extraPackageListGroups, extraPackagePurchase, footprintListActions, footprintListPreferences, generationModelGetFeaturesByModelVersionId, generationModelGetInferenceProfiles, generationModelGetLatestArtworksByModel, generationModelGetMostLikedArtworksByModel, generationModelGetMyModelPermission, generationModelGetSizeConfig, generationModelGetStyleKeys, generationModelGetTrendingArtworksByModel, generationModelImportExternalModel, i18nGetTrackUsage, i18nPostTrackUsage, imageCreate, imageFilterApplyFilter, internalImageCreate, internalReferralBind, internalTaskEditCreate, internalTaskGetById, internalTaskGetModeration, internalUserExternalProfilesBind, internalUserExternalProfilesListByUserId, kaisuukenCheck, kaisuukenList, kaisuukenLogs, kaisuukenSearch, kaisuukenSummary, kaisuukenTemplateList, kotoneCreditClaimMonthlyMembershipCreditPack, kotoneCreditExchangeCreditPack, kotoneCreditGetMonthlyMembershipGrantStatus, kotoneOrderCancel, kotoneOrderComplete, kotoneOrderConfirmRefund, kotoneOrderCreate, kotoneOrderGet, lotteryClaimReward, lotteryPurchaseToken, lotteryReset, lotteryRoll, mediaGetAudioUploadUrl, mediaGetAudioUrl, mediaGetMediaInfo, mediaGetVideoThumbnailId, mediaRegisterAudio, modelExperimentSessionGetExpSession, modelExperimentSessionSubmitPreference, notificationPreferenceGetNotificationPreference, notificationPreferenceSetNotificationPreference, oauth2Authorize, oauth2ClientAppleCallback, oauth2ClientCallback, oauth2ClientExchange, oauth2ClientNative, oauth2ClientStart, oauth2Consent, oauth2DeviceAuthorization, oauth2DeviceConsent, oauth2DeviceVerify, oauth2Introspect, oauth2Revoke, oauth2ServerMetadata, oauth2Token, type Options, orderGetById, paymentGetPaymentMethods, questV2ClaimReward, questV2ListCategories, questV2ListEventQuests, questV2ListFollowedPlatforms, questV2ListQuests, questV2ReportSocialFollow, questV2ReportUrlVisit, referenceVideoCreate, referralCampaignEntries, referralCampaignInviteeStatus, referralCampaignSummary, springPromotionEvent2026ChapterCompletions, springPromotionEvent2026ClaimFreePulls, springPromotionEvent2026CompleteChapter, springPromotionEvent2026DailyCheckIn, springPromotionEvent2026GrantTokens, springPromotionEvent2026Status, ssrClearExperimentCache, styleKeyRefCreate, surprisePackList, surprisePackPurchase, surprisePackReset, surprisePackUserPacks, tackAutocomplete, tackBatch, tackCuratedArtworks, tackGallery, tackSyncFromPixaiTack, tackTrending, tagSuggestPromptForImage, taskAcquirePreGenerated, taskCancelRunningTask, taskGetById, taskPredictWaitTime, testOpsCreateTestUser, tierRewardClaim, tierRewardClaimAllAvailable, tierRewardGetRewardTiers, tierRewardReset, uaNewbiePackGetSnapshot, uaNewbiePackMarkAhaShown, userCreateMyAccessToken, userCreateMyWebhook, userDecorationRelationGetUserDecorationRelation, userDecorationRelationUpdateUserDecorationRelation, userDeleteMyWebhook, userGetMe, userGetMyActivatedOtp, userGetMyDecorations, userGetMyMembership, userGetMyQuota, userGetUserActiveDecorations, userGetUserArtworksLatest, userGetUserArtworksMostLiked, userGetUserArtworksOldest, userGetUserById, userGetUserByUsername, userListMyAccessTokens, userListMyWebhooks, userOrderEmailList, userRevokeMyAccessToken } from '../sdk.gen';
import type { ArtworkBatchGetMediaIdData, ArtworkBatchGetMediaIdResponse, ArtworkCreateFromMediaData, ArtworkCreateFromMediaError, ArtworkCreateFromMediaResponse, ArtworkGetDailyRankingArtworksData, ArtworkGetDailyRankingArtworksResponse, ArtworkGetFollowingNewsArtworksData, ArtworkGetFollowingNewsArtworksResponse, ArtworkGetNewestArtworksData, ArtworkGetNewestArtworksResponse, ArtworkGetRecommendArtworksData, ArtworkGetRecommendArtworksError, ArtworkGetRecommendArtworksResponse, ArtworkGetRecommendArtworksVisitorData, ArtworkGetRecommendArtworksVisitorResponse, ArtworkGetSimilarArtworksData, ArtworkGetSimilarArtworksResponse, ArtworkGetTrendingArtworksData, ArtworkGetTrendingArtworksResponse, AttributionCreateClickEventData, AttributionCreateClickEventResponse, AttributionUpsertIdentifiersData, AttributionUpsertIdentifiersError, AttributionUpsertIdentifiersResponse, AuthResetForgetPasswordData, AuthSendForgetPasswordCodeData, AuthSignInWithEmailData, AuthSignInWithEmailResponse, AuthSignInWithGoogleTokenData, AuthSignInWithGoogleTokenResponse, BannerListData, BannerListResponse, CampaignAdsListData, CampaignAdsListResponse, ClaimClaimData, ClaimClaimError, ClaimClaimResponse, ClaimGetData, ClaimGetError, ClaimGetResponse, ClaimListData, ClaimListError, ClaimListResponse, ContentSafetyPreferenceGetContentSafetyPreferencesData, ContentSafetyPreferenceGetContentSafetyPreferencesError, ContentSafetyPreferenceGetContentSafetyPreferencesResponse, ContentSafetyPreferenceUpdateContentSafetyPreferenceData, ContentSafetyPreferenceUpdateContentSafetyPreferenceError, ContentSafetyPreferenceUpdateContentSafetyPreferenceResponse, ContestListData, ContestListResponse, ContestV2CreateCheckData, ContestV2CreateCheckResponse, ContestV2CreateData, ContestV2CreateError, ContestV2CreateResponse, ContestV2FollowData, ContestV2FollowError, ContestV2FollowResponse, ContestV2GetBySlugData, ContestV2GetBySlugError, ContestV2GetBySlugResponse, ContestV2ListArtworkByUserData, ContestV2ListArtworkByUserError, ContestV2ListArtworkByUserResponse, ContestV2ListArtworkData, ContestV2ListArtworkError, ContestV2ListArtworkResponse, ContestV2ListBannerData, ContestV2ListBannerResponse, ContestV2ListCreatedByUserData, ContestV2ListCreatedByUserResponse, ContestV2ListData, ContestV2ListFollowByUserData, ContestV2ListFollowByUserResponse, ContestV2ListResponse, ContestV2ListWinnersData, ContestV2ListWinnersError, ContestV2ListWinnersResponse, ContestV2SubmitArtworkData, ContestV2SubmitArtworkError, ContestV2SubmitArtworkResponse, ContestV2UnfollowData, ContestV2UnfollowError, ContestV2UnfollowResponse, CreditExchangeCreateTransactionData, CreditExchangeCreateTransactionError, CreditExchangeCreateTransactionResponse, CreditExchangeExternalTokenStatusData, CreditExchangeExternalTokenStatusError, CreditExchangeExternalTokenStatusResponse, CreditExchangeRedeemTokenData, CreditExchangeRedeemTokenError, CreditExchangeRedeemTokenResponse, CreditExchangeTokenSummaryData, CreditExchangeTokenSummaryError, CreditExchangeTokenSummaryResponse, DecorationBatchData, DecorationBatchResponse, DecorationGetDecorationData, DecorationGetDecorationError, DecorationGetDecorationResponse, EventPassListData, EventPassListResponse, EventPassPurchaseData, EventPassPurchaseError, EventPassPurchaseResponse, EventPassResetEventPassesData, EventPassResetEventPassesResponse, EventPassUserPassesData, EventPassUserPassesResponse, ExtraPackageBoostGetByCodeData, ExtraPackageBoostGetByCodeError, ExtraPackageBoostGetByCodeResponse, ExtraPackageBoostListMyBoostsData, ExtraPackageBoostListMyBoostsResponse, ExtraPackageConfirmAppleData, ExtraPackageConfirmAppleError, ExtraPackageConfirmAppleResponse, ExtraPackageConfirmGoogleData, ExtraPackageConfirmGoogleError, ExtraPackageConfirmGoogleResponse, ExtraPackageConfirmWebData, ExtraPackageConfirmWebError, ExtraPackageConfirmWebResponse, ExtraPackageGetData, ExtraPackageGetError, ExtraPackageGetResponse, ExtraPackageListData, ExtraPackageListGroupsData, ExtraPackageListGroupsResponse, ExtraPackageListResponse, ExtraPackagePurchaseData, ExtraPackagePurchaseError, ExtraPackagePurchaseResponse, FootprintListActionsData, FootprintListActionsError, FootprintListActionsResponse, FootprintListPreferencesData, FootprintListPreferencesError, FootprintListPreferencesResponse, GenerationModelGetFeaturesByModelVersionIdData, GenerationModelGetFeaturesByModelVersionIdError, GenerationModelGetFeaturesByModelVersionIdResponse, GenerationModelGetInferenceProfilesData, GenerationModelGetInferenceProfilesError, GenerationModelGetInferenceProfilesResponse, GenerationModelGetLatestArtworksByModelData, GenerationModelGetLatestArtworksByModelError, GenerationModelGetLatestArtworksByModelResponse, GenerationModelGetMostLikedArtworksByModelData, GenerationModelGetMostLikedArtworksByModelError, GenerationModelGetMostLikedArtworksByModelResponse, GenerationModelGetMyModelPermissionData, GenerationModelGetMyModelPermissionResponse, GenerationModelGetSizeConfigData, GenerationModelGetSizeConfigError, GenerationModelGetSizeConfigResponse, GenerationModelGetStyleKeysData, GenerationModelGetStyleKeysError, GenerationModelGetStyleKeysResponse, GenerationModelGetTrendingArtworksByModelData, GenerationModelGetTrendingArtworksByModelError, GenerationModelGetTrendingArtworksByModelResponse, GenerationModelImportExternalModelData, GenerationModelImportExternalModelError, GenerationModelImportExternalModelResponse, I18nGetTrackUsageData, I18nGetTrackUsageResponse, I18nPostTrackUsageData, ImageCreateData, ImageCreateError, ImageCreateResponse, ImageFilterApplyFilterData, ImageFilterApplyFilterError, ImageFilterApplyFilterResponse, InternalImageCreateData, InternalImageCreateError, InternalImageCreateResponse, InternalReferralBindData, InternalReferralBindError, InternalReferralBindResponse, InternalTaskEditCreateData, InternalTaskEditCreateError, InternalTaskEditCreateResponse, InternalTaskGetByIdData, InternalTaskGetByIdError, InternalTaskGetByIdResponse, InternalTaskGetModerationData, InternalTaskGetModerationError, InternalTaskGetModerationResponse, InternalUserExternalProfilesBindData, InternalUserExternalProfilesBindError, InternalUserExternalProfilesBindResponse, InternalUserExternalProfilesListByUserIdData, InternalUserExternalProfilesListByUserIdError, InternalUserExternalProfilesListByUserIdResponse, KaisuukenCheckData, KaisuukenCheckError, KaisuukenCheckResponse, KaisuukenListData, KaisuukenListError, KaisuukenListResponse, KaisuukenLogsData, KaisuukenLogsError, KaisuukenLogsResponse, KaisuukenSearchData, KaisuukenSearchError, KaisuukenSearchResponse, KaisuukenSummaryData, KaisuukenSummaryError, KaisuukenSummaryResponse, KaisuukenTemplateListData, KaisuukenTemplateListResponse, KotoneCreditClaimMonthlyMembershipCreditPackData, KotoneCreditClaimMonthlyMembershipCreditPackError, KotoneCreditClaimMonthlyMembershipCreditPackResponse, KotoneCreditExchangeCreditPackData, KotoneCreditExchangeCreditPackError, KotoneCreditExchangeCreditPackResponse, KotoneCreditGetMonthlyMembershipGrantStatusData, KotoneCreditGetMonthlyMembershipGrantStatusResponse, KotoneOrderCancelData, KotoneOrderCancelError, KotoneOrderCompleteData, KotoneOrderCompleteError, KotoneOrderConfirmRefundData, KotoneOrderConfirmRefundError, KotoneOrderCreateData, KotoneOrderCreateError, KotoneOrderCreateResponse, KotoneOrderGetData, KotoneOrderGetError, KotoneOrderGetResponse, LotteryClaimRewardData, LotteryClaimRewardResponse, LotteryPurchaseTokenData, LotteryResetData, LotteryRollData, LotteryRollResponse, MediaGetAudioUploadUrlData, MediaGetAudioUploadUrlError, MediaGetAudioUploadUrlResponse, MediaGetAudioUrlData, MediaGetAudioUrlError, MediaGetAudioUrlResponse, MediaGetMediaInfoData, MediaGetMediaInfoError, MediaGetMediaInfoResponse, MediaGetVideoThumbnailIdData, MediaGetVideoThumbnailIdError, MediaGetVideoThumbnailIdResponse, MediaRegisterAudioData, MediaRegisterAudioError, MediaRegisterAudioResponse, ModelExperimentSessionGetExpSessionData, ModelExperimentSessionGetExpSessionError, ModelExperimentSessionGetExpSessionResponse, ModelExperimentSessionSubmitPreferenceData, ModelExperimentSessionSubmitPreferenceError, ModelExperimentSessionSubmitPreferenceResponse, NotificationPreferenceGetNotificationPreferenceData, NotificationPreferenceGetNotificationPreferenceError, NotificationPreferenceGetNotificationPreferenceResponse, NotificationPreferenceSetNotificationPreferenceData, NotificationPreferenceSetNotificationPreferenceError, NotificationPreferenceSetNotificationPreferenceResponse, Oauth2AuthorizeData, Oauth2AuthorizeError, Oauth2AuthorizeResponse, Oauth2ClientAppleCallbackData, Oauth2ClientCallbackData, Oauth2ClientExchangeData, Oauth2ClientExchangeResponse, Oauth2ClientNativeData, Oauth2ClientNativeResponse, Oauth2ClientStartData, Oauth2ConsentData, Oauth2ConsentError, Oauth2ConsentResponse, Oauth2DeviceAuthorizationData, Oauth2DeviceAuthorizationError, Oauth2DeviceAuthorizationResponse, Oauth2DeviceConsentData, Oauth2DeviceConsentError, Oauth2DeviceConsentResponse, Oauth2DeviceVerifyData, Oauth2DeviceVerifyError, Oauth2DeviceVerifyResponse, Oauth2IntrospectData, Oauth2IntrospectError, Oauth2IntrospectResponse, Oauth2RevokeData, Oauth2RevokeError, Oauth2RevokeResponse, Oauth2ServerMetadataData, Oauth2ServerMetadataResponse, Oauth2TokenData, Oauth2TokenError, Oauth2TokenResponse, OrderGetByIdData, OrderGetByIdError, OrderGetByIdResponse, PaymentGetPaymentMethodsData, PaymentGetPaymentMethodsError, PaymentGetPaymentMethodsResponse, QuestV2ClaimRewardData, QuestV2ClaimRewardError, QuestV2ClaimRewardResponse, QuestV2ListCategoriesData, QuestV2ListCategoriesResponse, QuestV2ListEventQuestsData, QuestV2ListEventQuestsResponse, QuestV2ListFollowedPlatformsData, QuestV2ListFollowedPlatformsResponse, QuestV2ListQuestsData, QuestV2ListQuestsResponse, QuestV2ReportSocialFollowData, QuestV2ReportSocialFollowResponse, QuestV2ReportUrlVisitData, QuestV2ReportUrlVisitResponse, ReferenceVideoCreateData, ReferenceVideoCreateError, ReferenceVideoCreateResponse, ReferralCampaignEntriesData, ReferralCampaignEntriesError, ReferralCampaignEntriesResponse, ReferralCampaignInviteeStatusData, ReferralCampaignInviteeStatusError, ReferralCampaignInviteeStatusResponse, ReferralCampaignSummaryData, ReferralCampaignSummaryError, ReferralCampaignSummaryResponse, SpringPromotionEvent2026ChapterCompletionsData, SpringPromotionEvent2026ChapterCompletionsResponse, SpringPromotionEvent2026ClaimFreePullsData, SpringPromotionEvent2026ClaimFreePullsResponse, SpringPromotionEvent2026CompleteChapterData, SpringPromotionEvent2026CompleteChapterResponse, SpringPromotionEvent2026DailyCheckInData, SpringPromotionEvent2026GrantTokensData, SpringPromotionEvent2026StatusData, SpringPromotionEvent2026StatusResponse, SsrClearExperimentCacheData, SsrClearExperimentCacheError, SsrClearExperimentCacheResponse, StyleKeyRefCreateData, StyleKeyRefCreateError, StyleKeyRefCreateResponse, SurprisePackListData, SurprisePackListResponse, SurprisePackPurchaseData, SurprisePackPurchaseError, SurprisePackPurchaseResponse, SurprisePackResetData, SurprisePackResetResponse, SurprisePackUserPacksData, SurprisePackUserPacksResponse, TackAutocompleteData, TackAutocompleteResponse, TackBatchData, TackBatchResponse, TackCuratedArtworksData, TackCuratedArtworksError, TackCuratedArtworksResponse, TackGalleryData, TackGalleryResponse, TackSyncFromPixaiTackData, TackSyncFromPixaiTackError, TackSyncFromPixaiTackResponse, TackTrendingData, TackTrendingResponse, TagSuggestPromptForImageData, TagSuggestPromptForImageError, TagSuggestPromptForImageResponse, TaskAcquirePreGeneratedData, TaskAcquirePreGeneratedError, TaskAcquirePreGeneratedResponse, TaskCancelRunningTaskData, TaskCancelRunningTaskError, TaskCancelRunningTaskResponse, TaskGetByIdData, TaskGetByIdError, TaskGetByIdResponse, TaskPredictWaitTimeData, TaskPredictWaitTimeError, TaskPredictWaitTimeResponse, TestOpsCreateTestUserData, TestOpsCreateTestUserError, TestOpsCreateTestUserResponse, TierRewardClaimAllAvailableData, TierRewardClaimAllAvailableError, TierRewardClaimAllAvailableResponse, TierRewardClaimData, TierRewardClaimError, TierRewardClaimResponse, TierRewardGetRewardTiersData, TierRewardGetRewardTiersError, TierRewardGetRewardTiersResponse, TierRewardResetData, TierRewardResetError, UaNewbiePackGetSnapshotData, UaNewbiePackGetSnapshotError, UaNewbiePackGetSnapshotResponse, UaNewbiePackMarkAhaShownData, UaNewbiePackMarkAhaShownError, UaNewbiePackMarkAhaShownResponse, UserCreateMyAccessTokenData, UserCreateMyAccessTokenError, UserCreateMyAccessTokenResponse, UserCreateMyWebhookData, UserCreateMyWebhookError, UserCreateMyWebhookResponse, UserDecorationRelationGetUserDecorationRelationData, UserDecorationRelationGetUserDecorationRelationError, UserDecorationRelationGetUserDecorationRelationResponse, UserDecorationRelationUpdateUserDecorationRelationData, UserDecorationRelationUpdateUserDecorationRelationError, UserDecorationRelationUpdateUserDecorationRelationResponse, UserDeleteMyWebhookData, UserDeleteMyWebhookError, UserGetMeData, UserGetMeResponse, UserGetMyActivatedOtpData, UserGetMyActivatedOtpError, UserGetMyActivatedOtpResponse, UserGetMyDecorationsData, UserGetMyDecorationsError, UserGetMyDecorationsResponse, UserGetMyMembershipData, UserGetMyMembershipError, UserGetMyMembershipResponse, UserGetMyQuotaData, UserGetMyQuotaError, UserGetMyQuotaResponse, UserGetUserActiveDecorationsData, UserGetUserActiveDecorationsError, UserGetUserActiveDecorationsResponse, UserGetUserArtworksLatestData, UserGetUserArtworksLatestResponse, UserGetUserArtworksMostLikedData, UserGetUserArtworksMostLikedResponse, UserGetUserArtworksOldestData, UserGetUserArtworksOldestResponse, UserGetUserByIdData, UserGetUserByIdError, UserGetUserByIdResponse, UserGetUserByUsernameData, UserGetUserByUsernameError, UserGetUserByUsernameResponse, UserListMyAccessTokensData, UserListMyAccessTokensError, UserListMyAccessTokensResponse, UserListMyWebhooksData, UserListMyWebhooksError, UserListMyWebhooksResponse, UserOrderEmailListData, UserOrderEmailListError, UserOrderEmailListResponse, UserRevokeMyAccessTokenData, UserRevokeMyAccessTokenError } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const questV2ListCategoriesQueryKey = (options?: Options<QuestV2ListCategoriesData>) => createQueryKey('questV2ListCategories', options, false, ['QuestV2']);

/**
 * List quest categories
 */
export const questV2ListCategoriesOptions = (options?: Options<QuestV2ListCategoriesData>) => queryOptions<QuestV2ListCategoriesResponse, DefaultError, QuestV2ListCategoriesResponse, ReturnType<typeof questV2ListCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await questV2ListCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: questV2ListCategoriesQueryKey(options)
});

export const questV2ListQuestsQueryKey = (options?: Options<QuestV2ListQuestsData>) => createQueryKey('questV2ListQuests', options, false, ['QuestV2']);

/**
 * List quests for the current user
 */
export const questV2ListQuestsOptions = (options?: Options<QuestV2ListQuestsData>) => queryOptions<QuestV2ListQuestsResponse, DefaultError, QuestV2ListQuestsResponse, ReturnType<typeof questV2ListQuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await questV2ListQuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: questV2ListQuestsQueryKey(options)
});

export const questV2ListEventQuestsQueryKey = (options?: Options<QuestV2ListEventQuestsData>) => createQueryKey('questV2ListEventQuests', options, false, ['QuestV2']);

/**
 * List event quests for the current user
 */
export const questV2ListEventQuestsOptions = (options?: Options<QuestV2ListEventQuestsData>) => queryOptions<QuestV2ListEventQuestsResponse, DefaultError, QuestV2ListEventQuestsResponse, ReturnType<typeof questV2ListEventQuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await questV2ListEventQuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: questV2ListEventQuestsQueryKey(options)
});

/**
 * Claim reward for a completed quest
 */
export const questV2ClaimRewardMutation = (options?: Partial<Options<QuestV2ClaimRewardData>>): UseMutationOptions<QuestV2ClaimRewardResponse, QuestV2ClaimRewardError, Options<QuestV2ClaimRewardData>> => {
    const mutationOptions: UseMutationOptions<QuestV2ClaimRewardResponse, QuestV2ClaimRewardError, Options<QuestV2ClaimRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await questV2ClaimReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Report that the user visited a quest URL, advancing progress
 */
export const questV2ReportUrlVisitMutation = (options?: Partial<Options<QuestV2ReportUrlVisitData>>): UseMutationOptions<QuestV2ReportUrlVisitResponse, DefaultError, Options<QuestV2ReportUrlVisitData>> => {
    const mutationOptions: UseMutationOptions<QuestV2ReportUrlVisitResponse, DefaultError, Options<QuestV2ReportUrlVisitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await questV2ReportUrlVisit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Report that the user followed a social platform, advancing progress
 */
export const questV2ReportSocialFollowMutation = (options?: Partial<Options<QuestV2ReportSocialFollowData>>): UseMutationOptions<QuestV2ReportSocialFollowResponse, DefaultError, Options<QuestV2ReportSocialFollowData>> => {
    const mutationOptions: UseMutationOptions<QuestV2ReportSocialFollowResponse, DefaultError, Options<QuestV2ReportSocialFollowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await questV2ReportSocialFollow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const questV2ListFollowedPlatformsQueryKey = (options?: Options<QuestV2ListFollowedPlatformsData>) => createQueryKey('questV2ListFollowedPlatforms', options, false, ['QuestV2']);

/**
 * List platforms the current user has followed
 */
export const questV2ListFollowedPlatformsOptions = (options?: Options<QuestV2ListFollowedPlatformsData>) => queryOptions<QuestV2ListFollowedPlatformsResponse, DefaultError, QuestV2ListFollowedPlatformsResponse, ReturnType<typeof questV2ListFollowedPlatformsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await questV2ListFollowedPlatforms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: questV2ListFollowedPlatformsQueryKey(options)
});

export const springPromotionEvent2026StatusQueryKey = (options?: Options<SpringPromotionEvent2026StatusData>) => createQueryKey('springPromotionEvent2026Status', options, false, ['SpringPromotionEvent2026']);

/**
 * Get Spring Promotion 2026 lottery status for current user
 */
export const springPromotionEvent2026StatusOptions = (options?: Options<SpringPromotionEvent2026StatusData>) => queryOptions<SpringPromotionEvent2026StatusResponse, DefaultError, SpringPromotionEvent2026StatusResponse, ReturnType<typeof springPromotionEvent2026StatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await springPromotionEvent2026Status({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: springPromotionEvent2026StatusQueryKey(options)
});

/**
 * Claim daily free pulls for Spring Promotion 2026
 */
export const springPromotionEvent2026ClaimFreePullsMutation = (options?: Partial<Options<SpringPromotionEvent2026ClaimFreePullsData>>): UseMutationOptions<SpringPromotionEvent2026ClaimFreePullsResponse, DefaultError, Options<SpringPromotionEvent2026ClaimFreePullsData>> => {
    const mutationOptions: UseMutationOptions<SpringPromotionEvent2026ClaimFreePullsResponse, DefaultError, Options<SpringPromotionEvent2026ClaimFreePullsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await springPromotionEvent2026ClaimFreePulls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark a drama chapter as completed and grant rewards
 */
export const springPromotionEvent2026CompleteChapterMutation = (options?: Partial<Options<SpringPromotionEvent2026CompleteChapterData>>): UseMutationOptions<SpringPromotionEvent2026CompleteChapterResponse, DefaultError, Options<SpringPromotionEvent2026CompleteChapterData>> => {
    const mutationOptions: UseMutationOptions<SpringPromotionEvent2026CompleteChapterResponse, DefaultError, Options<SpringPromotionEvent2026CompleteChapterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await springPromotionEvent2026CompleteChapter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const springPromotionEvent2026ChapterCompletionsQueryKey = (options?: Options<SpringPromotionEvent2026ChapterCompletionsData>) => createQueryKey('springPromotionEvent2026ChapterCompletions', options, false, ['SpringPromotionEvent2026']);

/**
 * List drama chapters the current user has completed
 */
export const springPromotionEvent2026ChapterCompletionsOptions = (options?: Options<SpringPromotionEvent2026ChapterCompletionsData>) => queryOptions<SpringPromotionEvent2026ChapterCompletionsResponse, DefaultError, SpringPromotionEvent2026ChapterCompletionsResponse, ReturnType<typeof springPromotionEvent2026ChapterCompletionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await springPromotionEvent2026ChapterCompletions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: springPromotionEvent2026ChapterCompletionsQueryKey(options)
});

/**
 * Trigger daily check-in quest for Spring Promotion 2026
 */
export const springPromotionEvent2026DailyCheckInMutation = (options?: Partial<Options<SpringPromotionEvent2026DailyCheckInData>>): UseMutationOptions<unknown, DefaultError, Options<SpringPromotionEvent2026DailyCheckInData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SpringPromotionEvent2026DailyCheckInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await springPromotionEvent2026DailyCheckIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Grant event tokens to the caller (admin/debug)
 */
export const springPromotionEvent2026GrantTokensMutation = (options?: Partial<Options<SpringPromotionEvent2026GrantTokensData>>): UseMutationOptions<unknown, DefaultError, Options<SpringPromotionEvent2026GrantTokensData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SpringPromotionEvent2026GrantTokensData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await springPromotionEvent2026GrantTokens({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const eventPassListQueryKey = (options: Options<EventPassListData>) => createQueryKey('eventPassList', options, false, ['EventPass']);

/**
 * List available event passes
 */
export const eventPassListOptions = (options: Options<EventPassListData>) => queryOptions<EventPassListResponse, DefaultError, EventPassListResponse, ReturnType<typeof eventPassListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await eventPassList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: eventPassListQueryKey(options)
});

export const eventPassUserPassesQueryKey = (options: Options<EventPassUserPassesData>) => createQueryKey('eventPassUserPasses', options, false, ['EventPass']);

/**
 * Get current user pass records
 */
export const eventPassUserPassesOptions = (options: Options<EventPassUserPassesData>) => queryOptions<EventPassUserPassesResponse, DefaultError, EventPassUserPassesResponse, ReturnType<typeof eventPassUserPassesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await eventPassUserPasses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: eventPassUserPassesQueryKey(options)
});

/**
 * Purchase a pass
 */
export const eventPassPurchaseMutation = (options?: Partial<Options<EventPassPurchaseData>>): UseMutationOptions<EventPassPurchaseResponse, EventPassPurchaseError, Options<EventPassPurchaseData>> => {
    const mutationOptions: UseMutationOptions<EventPassPurchaseResponse, EventPassPurchaseError, Options<EventPassPurchaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await eventPassPurchase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete all user event passes for a given event (admin only)
 */
export const eventPassResetEventPassesMutation = (options?: Partial<Options<EventPassResetEventPassesData>>): UseMutationOptions<EventPassResetEventPassesResponse, DefaultError, Options<EventPassResetEventPassesData>> => {
    const mutationOptions: UseMutationOptions<EventPassResetEventPassesResponse, DefaultError, Options<EventPassResetEventPassesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await eventPassResetEventPasses({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const surprisePackListQueryKey = (options: Options<SurprisePackListData>) => createQueryKey('surprisePackList', options, false, ['SurprisePack']);

/**
 * List available surprise pack SKUs
 */
export const surprisePackListOptions = (options: Options<SurprisePackListData>) => queryOptions<SurprisePackListResponse, DefaultError, SurprisePackListResponse, ReturnType<typeof surprisePackListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await surprisePackList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: surprisePackListQueryKey(options)
});

export const surprisePackUserPacksQueryKey = (options: Options<SurprisePackUserPacksData>) => createQueryKey('surprisePackUserPacks', options, false, ['SurprisePack']);

/**
 * Get current user surprise pack records
 */
export const surprisePackUserPacksOptions = (options: Options<SurprisePackUserPacksData>) => queryOptions<SurprisePackUserPacksResponse, DefaultError, SurprisePackUserPacksResponse, ReturnType<typeof surprisePackUserPacksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await surprisePackUserPacks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: surprisePackUserPacksQueryKey(options)
});

/**
 * Purchase a surprise pack
 */
export const surprisePackPurchaseMutation = (options?: Partial<Options<SurprisePackPurchaseData>>): UseMutationOptions<SurprisePackPurchaseResponse, SurprisePackPurchaseError, Options<SurprisePackPurchaseData>> => {
    const mutationOptions: UseMutationOptions<SurprisePackPurchaseResponse, SurprisePackPurchaseError, Options<SurprisePackPurchaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await surprisePackPurchase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete all user surprise packs for a given event (admin only)
 */
export const surprisePackResetMutation = (options?: Partial<Options<SurprisePackResetData>>): UseMutationOptions<SurprisePackResetResponse, DefaultError, Options<SurprisePackResetData>> => {
    const mutationOptions: UseMutationOptions<SurprisePackResetResponse, DefaultError, Options<SurprisePackResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await surprisePackReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a new artwork from uploaded media
 *
 * Creates a new artwork from user-uploaded media. Requires authentication and Turnstile verification for web clients.
 */
export const artworkCreateFromMediaMutation = (options?: Partial<Options<ArtworkCreateFromMediaData>>): UseMutationOptions<ArtworkCreateFromMediaResponse, ArtworkCreateFromMediaError, Options<ArtworkCreateFromMediaData>> => {
    const mutationOptions: UseMutationOptions<ArtworkCreateFromMediaResponse, ArtworkCreateFromMediaError, Options<ArtworkCreateFromMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await artworkCreateFromMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch get media IDs for artworks
 */
export const artworkBatchGetMediaIdMutation = (options?: Partial<Options<ArtworkBatchGetMediaIdData>>): UseMutationOptions<ArtworkBatchGetMediaIdResponse, DefaultError, Options<ArtworkBatchGetMediaIdData>> => {
    const mutationOptions: UseMutationOptions<ArtworkBatchGetMediaIdResponse, DefaultError, Options<ArtworkBatchGetMediaIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await artworkBatchGetMediaId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const artworkGetSimilarArtworksQueryKey = (options: Options<ArtworkGetSimilarArtworksData>) => createQueryKey('artworkGetSimilarArtworks', options, false, ['Artwork']);

/**
 * Get similar artworks
 *
 * Returns artworks similar to the given artwork, using vector similarity search on image embeddings.
 */
export const artworkGetSimilarArtworksOptions = (options: Options<ArtworkGetSimilarArtworksData>) => queryOptions<ArtworkGetSimilarArtworksResponse, DefaultError, ArtworkGetSimilarArtworksResponse, ReturnType<typeof artworkGetSimilarArtworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await artworkGetSimilarArtworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetSimilarArtworksQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const artworkGetSimilarArtworksInfiniteQueryKey = (options: Options<ArtworkGetSimilarArtworksData>): QueryKey<Options<ArtworkGetSimilarArtworksData>> => createQueryKey('artworkGetSimilarArtworks', options, true);

/**
 * Get similar artworks
 *
 * Returns artworks similar to the given artwork, using vector similarity search on image embeddings.
 */
export const artworkGetSimilarArtworksInfiniteOptions = (options: Options<ArtworkGetSimilarArtworksData>) => infiniteQueryOptions<ArtworkGetSimilarArtworksResponse, DefaultError, InfiniteData<ArtworkGetSimilarArtworksResponse>, QueryKey<Options<ArtworkGetSimilarArtworksData>>, string | Pick<QueryKey<Options<ArtworkGetSimilarArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ArtworkGetSimilarArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await artworkGetSimilarArtworks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetSimilarArtworksInfiniteQueryKey(options)
});

export const artworkGetRecommendArtworksQueryKey = (options?: Options<ArtworkGetRecommendArtworksData>) => createQueryKey('artworkGetRecommendArtworks', options, false, ['Artwork']);

/**
 * Get personalized recommended artworks feed
 *
 * Returns personalized recommended artworks for the authenticated user.
 */
export const artworkGetRecommendArtworksOptions = (options?: Options<ArtworkGetRecommendArtworksData>) => queryOptions<ArtworkGetRecommendArtworksResponse, ArtworkGetRecommendArtworksError, ArtworkGetRecommendArtworksResponse, ReturnType<typeof artworkGetRecommendArtworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await artworkGetRecommendArtworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetRecommendArtworksQueryKey(options)
});

export const artworkGetRecommendArtworksInfiniteQueryKey = (options?: Options<ArtworkGetRecommendArtworksData>): QueryKey<Options<ArtworkGetRecommendArtworksData>> => createQueryKey('artworkGetRecommendArtworks', options, true);

/**
 * Get personalized recommended artworks feed
 *
 * Returns personalized recommended artworks for the authenticated user.
 */
export const artworkGetRecommendArtworksInfiniteOptions = (options?: Options<ArtworkGetRecommendArtworksData>) => infiniteQueryOptions<ArtworkGetRecommendArtworksResponse, ArtworkGetRecommendArtworksError, InfiniteData<ArtworkGetRecommendArtworksResponse>, QueryKey<Options<ArtworkGetRecommendArtworksData>>, string | Pick<QueryKey<Options<ArtworkGetRecommendArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ArtworkGetRecommendArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await artworkGetRecommendArtworks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetRecommendArtworksInfiniteQueryKey(options)
});

export const artworkGetRecommendArtworksVisitorQueryKey = (options?: Options<ArtworkGetRecommendArtworksVisitorData>) => createQueryKey('artworkGetRecommendArtworksVisitor', options, false, ['Artwork']);

/**
 * Get recommended artworks feed for visitors
 *
 * Returns recommended artworks for unauthenticated visitors.
 */
export const artworkGetRecommendArtworksVisitorOptions = (options?: Options<ArtworkGetRecommendArtworksVisitorData>) => queryOptions<ArtworkGetRecommendArtworksVisitorResponse, DefaultError, ArtworkGetRecommendArtworksVisitorResponse, ReturnType<typeof artworkGetRecommendArtworksVisitorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await artworkGetRecommendArtworksVisitor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetRecommendArtworksVisitorQueryKey(options)
});

export const artworkGetRecommendArtworksVisitorInfiniteQueryKey = (options?: Options<ArtworkGetRecommendArtworksVisitorData>): QueryKey<Options<ArtworkGetRecommendArtworksVisitorData>> => createQueryKey('artworkGetRecommendArtworksVisitor', options, true);

/**
 * Get recommended artworks feed for visitors
 *
 * Returns recommended artworks for unauthenticated visitors.
 */
export const artworkGetRecommendArtworksVisitorInfiniteOptions = (options?: Options<ArtworkGetRecommendArtworksVisitorData>) => infiniteQueryOptions<ArtworkGetRecommendArtworksVisitorResponse, DefaultError, InfiniteData<ArtworkGetRecommendArtworksVisitorResponse>, QueryKey<Options<ArtworkGetRecommendArtworksVisitorData>>, string | Pick<QueryKey<Options<ArtworkGetRecommendArtworksVisitorData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ArtworkGetRecommendArtworksVisitorData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await artworkGetRecommendArtworksVisitor({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetRecommendArtworksVisitorInfiniteQueryKey(options)
});

export const artworkGetTrendingArtworksQueryKey = (options?: Options<ArtworkGetTrendingArtworksData>) => createQueryKey('artworkGetTrendingArtworks', options, false, ['Artwork']);

/**
 * Get trending artworks feed
 *
 * Returns the weekly trending artworks feed ranked by a velocity-weighted like score.
 */
export const artworkGetTrendingArtworksOptions = (options?: Options<ArtworkGetTrendingArtworksData>) => queryOptions<ArtworkGetTrendingArtworksResponse, DefaultError, ArtworkGetTrendingArtworksResponse, ReturnType<typeof artworkGetTrendingArtworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await artworkGetTrendingArtworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetTrendingArtworksQueryKey(options)
});

export const artworkGetTrendingArtworksInfiniteQueryKey = (options?: Options<ArtworkGetTrendingArtworksData>): QueryKey<Options<ArtworkGetTrendingArtworksData>> => createQueryKey('artworkGetTrendingArtworks', options, true);

/**
 * Get trending artworks feed
 *
 * Returns the weekly trending artworks feed ranked by a velocity-weighted like score.
 */
export const artworkGetTrendingArtworksInfiniteOptions = (options?: Options<ArtworkGetTrendingArtworksData>) => infiniteQueryOptions<ArtworkGetTrendingArtworksResponse, DefaultError, InfiniteData<ArtworkGetTrendingArtworksResponse>, QueryKey<Options<ArtworkGetTrendingArtworksData>>, string | Pick<QueryKey<Options<ArtworkGetTrendingArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ArtworkGetTrendingArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await artworkGetTrendingArtworks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetTrendingArtworksInfiniteQueryKey(options)
});

export const artworkGetDailyRankingArtworksQueryKey = (options?: Options<ArtworkGetDailyRankingArtworksData>) => createQueryKey('artworkGetDailyRankingArtworks', options, false, ['Artwork']);

/**
 * Get daily-ranking artworks feed
 *
 * Returns the deduplicated daily ranking feed (one artwork per author, ranked by likedCount).
 */
export const artworkGetDailyRankingArtworksOptions = (options?: Options<ArtworkGetDailyRankingArtworksData>) => queryOptions<ArtworkGetDailyRankingArtworksResponse, DefaultError, ArtworkGetDailyRankingArtworksResponse, ReturnType<typeof artworkGetDailyRankingArtworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await artworkGetDailyRankingArtworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetDailyRankingArtworksQueryKey(options)
});

export const artworkGetDailyRankingArtworksInfiniteQueryKey = (options?: Options<ArtworkGetDailyRankingArtworksData>): QueryKey<Options<ArtworkGetDailyRankingArtworksData>> => createQueryKey('artworkGetDailyRankingArtworks', options, true);

/**
 * Get daily-ranking artworks feed
 *
 * Returns the deduplicated daily ranking feed (one artwork per author, ranked by likedCount).
 */
export const artworkGetDailyRankingArtworksInfiniteOptions = (options?: Options<ArtworkGetDailyRankingArtworksData>) => infiniteQueryOptions<ArtworkGetDailyRankingArtworksResponse, DefaultError, InfiniteData<ArtworkGetDailyRankingArtworksResponse>, QueryKey<Options<ArtworkGetDailyRankingArtworksData>>, string | Pick<QueryKey<Options<ArtworkGetDailyRankingArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ArtworkGetDailyRankingArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await artworkGetDailyRankingArtworks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetDailyRankingArtworksInfiniteQueryKey(options)
});

export const artworkGetFollowingNewsArtworksQueryKey = (options?: Options<ArtworkGetFollowingNewsArtworksData>) => createQueryKey('artworkGetFollowingNewsArtworks', options, false, ['Artwork']);

/**
 * Get following-news artworks feed
 *
 * Returns the latest public artwork from authors the current user follows, sorted by createdAt desc. Returns an empty page for unauthenticated requests.
 */
export const artworkGetFollowingNewsArtworksOptions = (options?: Options<ArtworkGetFollowingNewsArtworksData>) => queryOptions<ArtworkGetFollowingNewsArtworksResponse, DefaultError, ArtworkGetFollowingNewsArtworksResponse, ReturnType<typeof artworkGetFollowingNewsArtworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await artworkGetFollowingNewsArtworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetFollowingNewsArtworksQueryKey(options)
});

export const artworkGetFollowingNewsArtworksInfiniteQueryKey = (options?: Options<ArtworkGetFollowingNewsArtworksData>): QueryKey<Options<ArtworkGetFollowingNewsArtworksData>> => createQueryKey('artworkGetFollowingNewsArtworks', options, true);

/**
 * Get following-news artworks feed
 *
 * Returns the latest public artwork from authors the current user follows, sorted by createdAt desc. Returns an empty page for unauthenticated requests.
 */
export const artworkGetFollowingNewsArtworksInfiniteOptions = (options?: Options<ArtworkGetFollowingNewsArtworksData>) => infiniteQueryOptions<ArtworkGetFollowingNewsArtworksResponse, DefaultError, InfiniteData<ArtworkGetFollowingNewsArtworksResponse>, QueryKey<Options<ArtworkGetFollowingNewsArtworksData>>, string | Pick<QueryKey<Options<ArtworkGetFollowingNewsArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ArtworkGetFollowingNewsArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await artworkGetFollowingNewsArtworks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetFollowingNewsArtworksInfiniteQueryKey(options)
});

export const artworkGetNewestArtworksQueryKey = (options?: Options<ArtworkGetNewestArtworksData>) => createQueryKey('artworkGetNewestArtworks', options, false, ['Artwork']);

/**
 * Get newest artworks feed
 *
 * Returns public artworks sorted by createdAt desc. Visitor-cacheable for anonymous callers; logged-in responses skip the edge cache.
 */
export const artworkGetNewestArtworksOptions = (options?: Options<ArtworkGetNewestArtworksData>) => queryOptions<ArtworkGetNewestArtworksResponse, DefaultError, ArtworkGetNewestArtworksResponse, ReturnType<typeof artworkGetNewestArtworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await artworkGetNewestArtworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetNewestArtworksQueryKey(options)
});

export const artworkGetNewestArtworksInfiniteQueryKey = (options?: Options<ArtworkGetNewestArtworksData>): QueryKey<Options<ArtworkGetNewestArtworksData>> => createQueryKey('artworkGetNewestArtworks', options, true);

/**
 * Get newest artworks feed
 *
 * Returns public artworks sorted by createdAt desc. Visitor-cacheable for anonymous callers; logged-in responses skip the edge cache.
 */
export const artworkGetNewestArtworksInfiniteOptions = (options?: Options<ArtworkGetNewestArtworksData>) => infiniteQueryOptions<ArtworkGetNewestArtworksResponse, DefaultError, InfiniteData<ArtworkGetNewestArtworksResponse>, QueryKey<Options<ArtworkGetNewestArtworksData>>, string | Pick<QueryKey<Options<ArtworkGetNewestArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ArtworkGetNewestArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await artworkGetNewestArtworks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artworkGetNewestArtworksInfiniteQueryKey(options)
});

/**
 * Upsert device/browser identifiers
 *
 * Upserts device and browser identifiers for the current session. Requires authentication.
 */
export const attributionUpsertIdentifiersMutation = (options?: Partial<Options<AttributionUpsertIdentifiersData>>): UseMutationOptions<AttributionUpsertIdentifiersResponse, AttributionUpsertIdentifiersError, Options<AttributionUpsertIdentifiersData>> => {
    const mutationOptions: UseMutationOptions<AttributionUpsertIdentifiersResponse, AttributionUpsertIdentifiersError, Options<AttributionUpsertIdentifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attributionUpsertIdentifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record an ad click event
 *
 * Records an ad click event for attribution tracking. No authentication required.
 */
export const attributionCreateClickEventMutation = (options?: Partial<Options<AttributionCreateClickEventData>>): UseMutationOptions<AttributionCreateClickEventResponse, DefaultError, Options<AttributionCreateClickEventData>> => {
    const mutationOptions: UseMutationOptions<AttributionCreateClickEventResponse, DefaultError, Options<AttributionCreateClickEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attributionCreateClickEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send a verification code to the given email so the user can reset their password
 */
export const authSendForgetPasswordCodeMutation = (options?: Partial<Options<AuthSendForgetPasswordCodeData>>): UseMutationOptions<unknown, DefaultError, Options<AuthSendForgetPasswordCodeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthSendForgetPasswordCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authSendForgetPasswordCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset the password for the given email using the verification code
 */
export const authResetForgetPasswordMutation = (options?: Partial<Options<AuthResetForgetPasswordData>>): UseMutationOptions<unknown, DefaultError, Options<AuthResetForgetPasswordData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthResetForgetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authResetForgetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign in with email and password. Creates a new account when no user is registered under the submitted email.
 */
export const authSignInWithEmailMutation = (options?: Partial<Options<AuthSignInWithEmailData>>): UseMutationOptions<AuthSignInWithEmailResponse, DefaultError, Options<AuthSignInWithEmailData>> => {
    const mutationOptions: UseMutationOptions<AuthSignInWithEmailResponse, DefaultError, Options<AuthSignInWithEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authSignInWithEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign in with a Google identity token. Creates an account if none is linked.
 */
export const authSignInWithGoogleTokenMutation = (options?: Partial<Options<AuthSignInWithGoogleTokenData>>): UseMutationOptions<AuthSignInWithGoogleTokenResponse, DefaultError, Options<AuthSignInWithGoogleTokenData>> => {
    const mutationOptions: UseMutationOptions<AuthSignInWithGoogleTokenResponse, DefaultError, Options<AuthSignInWithGoogleTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authSignInWithGoogleToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userGetMeQueryKey = (options?: Options<UserGetMeData>) => createQueryKey('userGetMe', options, false, ['User']);

export const userGetMeOptions = (options?: Options<UserGetMeData>) => queryOptions<UserGetMeResponse, DefaultError, UserGetMeResponse, ReturnType<typeof userGetMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetMeQueryKey(options)
});

export const userGetUserByIdQueryKey = (options: Options<UserGetUserByIdData>) => createQueryKey('userGetUserById', options, false, ['User']);

export const userGetUserByIdOptions = (options: Options<UserGetUserByIdData>) => queryOptions<UserGetUserByIdResponse, UserGetUserByIdError, UserGetUserByIdResponse, ReturnType<typeof userGetUserByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetUserById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserByIdQueryKey(options)
});

export const userGetUserByUsernameQueryKey = (options: Options<UserGetUserByUsernameData>) => createQueryKey('userGetUserByUsername', options, false, ['User']);

export const userGetUserByUsernameOptions = (options: Options<UserGetUserByUsernameData>) => queryOptions<UserGetUserByUsernameResponse, UserGetUserByUsernameError, UserGetUserByUsernameResponse, ReturnType<typeof userGetUserByUsernameQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetUserByUsername({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserByUsernameQueryKey(options)
});

export const userGetMyMembershipQueryKey = (options?: Options<UserGetMyMembershipData>) => createQueryKey('userGetMyMembership', options, false, ['User']);

/**
 * Get membership info for current user
 */
export const userGetMyMembershipOptions = (options?: Options<UserGetMyMembershipData>) => queryOptions<UserGetMyMembershipResponse, UserGetMyMembershipError, UserGetMyMembershipResponse, ReturnType<typeof userGetMyMembershipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetMyMembership({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetMyMembershipQueryKey(options)
});

export const userGetMyDecorationsQueryKey = (options?: Options<UserGetMyDecorationsData>) => createQueryKey('userGetMyDecorations', options, false, ['User']);

/**
 * Get active decorations for current user
 */
export const userGetMyDecorationsOptions = (options?: Options<UserGetMyDecorationsData>) => queryOptions<UserGetMyDecorationsResponse, UserGetMyDecorationsError, UserGetMyDecorationsResponse, ReturnType<typeof userGetMyDecorationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetMyDecorations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetMyDecorationsQueryKey(options)
});

export const userGetUserActiveDecorationsQueryKey = (options: Options<UserGetUserActiveDecorationsData>) => createQueryKey('userGetUserActiveDecorations', options, false, ['User']);

/**
 * Get active decorations for a user
 */
export const userGetUserActiveDecorationsOptions = (options: Options<UserGetUserActiveDecorationsData>) => queryOptions<UserGetUserActiveDecorationsResponse, UserGetUserActiveDecorationsError, UserGetUserActiveDecorationsResponse, ReturnType<typeof userGetUserActiveDecorationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetUserActiveDecorations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserActiveDecorationsQueryKey(options)
});

export const userGetMyActivatedOtpQueryKey = (options?: Options<UserGetMyActivatedOtpData>) => createQueryKey('userGetMyActivatedOtp', options, false, ['User']);

/**
 * Get activated OTP info for current user
 */
export const userGetMyActivatedOtpOptions = (options?: Options<UserGetMyActivatedOtpData>) => queryOptions<UserGetMyActivatedOtpResponse, UserGetMyActivatedOtpError, UserGetMyActivatedOtpResponse, ReturnType<typeof userGetMyActivatedOtpQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetMyActivatedOtp({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetMyActivatedOtpQueryKey(options)
});

export const userGetUserArtworksLatestQueryKey = (options: Options<UserGetUserArtworksLatestData>) => createQueryKey('userGetUserArtworksLatest', options, false, ['User']);

/**
 * List a user’s artworks, newest first
 *
 * Returns the given user’s artworks ordered by `createdAt` descending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward in the orderBy sequence → older items), **previous page** = `last` + `before` (walks backward → newer items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksLatestOptions = (options: Options<UserGetUserArtworksLatestData>) => queryOptions<UserGetUserArtworksLatestResponse, DefaultError, UserGetUserArtworksLatestResponse, ReturnType<typeof userGetUserArtworksLatestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetUserArtworksLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserArtworksLatestQueryKey(options)
});

export const userGetUserArtworksLatestInfiniteQueryKey = (options: Options<UserGetUserArtworksLatestData>): QueryKey<Options<UserGetUserArtworksLatestData>> => createQueryKey('userGetUserArtworksLatest', options, true);

/**
 * List a user’s artworks, newest first
 *
 * Returns the given user’s artworks ordered by `createdAt` descending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward in the orderBy sequence → older items), **previous page** = `last` + `before` (walks backward → newer items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksLatestInfiniteOptions = (options: Options<UserGetUserArtworksLatestData>) => infiniteQueryOptions<UserGetUserArtworksLatestResponse, DefaultError, InfiniteData<UserGetUserArtworksLatestResponse>, QueryKey<Options<UserGetUserArtworksLatestData>>, string | Pick<QueryKey<Options<UserGetUserArtworksLatestData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<UserGetUserArtworksLatestData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await userGetUserArtworksLatest({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserArtworksLatestInfiniteQueryKey(options)
});

export const userGetUserArtworksOldestQueryKey = (options: Options<UserGetUserArtworksOldestData>) => createQueryKey('userGetUserArtworksOldest', options, false, ['User']);

/**
 * List a user’s artworks, oldest first
 *
 * Returns the given user’s artworks ordered by `createdAt` ascending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward → newer items), **previous page** = `last` + `before` (walks backward → older items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksOldestOptions = (options: Options<UserGetUserArtworksOldestData>) => queryOptions<UserGetUserArtworksOldestResponse, DefaultError, UserGetUserArtworksOldestResponse, ReturnType<typeof userGetUserArtworksOldestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetUserArtworksOldest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserArtworksOldestQueryKey(options)
});

export const userGetUserArtworksOldestInfiniteQueryKey = (options: Options<UserGetUserArtworksOldestData>): QueryKey<Options<UserGetUserArtworksOldestData>> => createQueryKey('userGetUserArtworksOldest', options, true);

/**
 * List a user’s artworks, oldest first
 *
 * Returns the given user’s artworks ordered by `createdAt` ascending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward → newer items), **previous page** = `last` + `before` (walks backward → older items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksOldestInfiniteOptions = (options: Options<UserGetUserArtworksOldestData>) => infiniteQueryOptions<UserGetUserArtworksOldestResponse, DefaultError, InfiniteData<UserGetUserArtworksOldestResponse>, QueryKey<Options<UserGetUserArtworksOldestData>>, string | Pick<QueryKey<Options<UserGetUserArtworksOldestData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<UserGetUserArtworksOldestData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await userGetUserArtworksOldest({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserArtworksOldestInfiniteQueryKey(options)
});

export const userGetUserArtworksMostLikedQueryKey = (options: Options<UserGetUserArtworksMostLikedData>) => createQueryKey('userGetUserArtworksMostLiked', options, false, ['User']);

/**
 * List a user’s artworks, most-liked first
 *
 * Returns the given user’s artworks ordered by `likedCount` descending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward → less-liked items), **previous page** = `last` + `before` (walks backward → more-liked items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksMostLikedOptions = (options: Options<UserGetUserArtworksMostLikedData>) => queryOptions<UserGetUserArtworksMostLikedResponse, DefaultError, UserGetUserArtworksMostLikedResponse, ReturnType<typeof userGetUserArtworksMostLikedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetUserArtworksMostLiked({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserArtworksMostLikedQueryKey(options)
});

export const userGetUserArtworksMostLikedInfiniteQueryKey = (options: Options<UserGetUserArtworksMostLikedData>): QueryKey<Options<UserGetUserArtworksMostLikedData>> => createQueryKey('userGetUserArtworksMostLiked', options, true);

/**
 * List a user’s artworks, most-liked first
 *
 * Returns the given user’s artworks ordered by `likedCount` descending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward → less-liked items), **previous page** = `last` + `before` (walks backward → more-liked items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksMostLikedInfiniteOptions = (options: Options<UserGetUserArtworksMostLikedData>) => infiniteQueryOptions<UserGetUserArtworksMostLikedResponse, DefaultError, InfiniteData<UserGetUserArtworksMostLikedResponse>, QueryKey<Options<UserGetUserArtworksMostLikedData>>, string | Pick<QueryKey<Options<UserGetUserArtworksMostLikedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<UserGetUserArtworksMostLikedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await userGetUserArtworksMostLiked({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetUserArtworksMostLikedInfiniteQueryKey(options)
});

export const userGetMyQuotaQueryKey = (options?: Options<UserGetMyQuotaData>) => createQueryKey('userGetMyQuota', options, false, ['User']);

/**
 * Get quota balance for current user
 */
export const userGetMyQuotaOptions = (options?: Options<UserGetMyQuotaData>) => queryOptions<UserGetMyQuotaResponse, UserGetMyQuotaError, UserGetMyQuotaResponse, ReturnType<typeof userGetMyQuotaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetMyQuota({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetMyQuotaQueryKey(options)
});

export const userListMyAccessTokensQueryKey = (options?: Options<UserListMyAccessTokensData>) => createQueryKey('userListMyAccessTokens', options, false, ['User']);

/**
 * List active access tokens for current user
 */
export const userListMyAccessTokensOptions = (options?: Options<UserListMyAccessTokensData>) => queryOptions<UserListMyAccessTokensResponse, UserListMyAccessTokensError, UserListMyAccessTokensResponse, ReturnType<typeof userListMyAccessTokensQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userListMyAccessTokens({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userListMyAccessTokensQueryKey(options)
});

/**
 * Create a new access token for current user
 */
export const userCreateMyAccessTokenMutation = (options?: Partial<Options<UserCreateMyAccessTokenData>>): UseMutationOptions<UserCreateMyAccessTokenResponse, UserCreateMyAccessTokenError, Options<UserCreateMyAccessTokenData>> => {
    const mutationOptions: UseMutationOptions<UserCreateMyAccessTokenResponse, UserCreateMyAccessTokenError, Options<UserCreateMyAccessTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userCreateMyAccessToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke an access token
 */
export const userRevokeMyAccessTokenMutation = (options?: Partial<Options<UserRevokeMyAccessTokenData>>): UseMutationOptions<unknown, UserRevokeMyAccessTokenError, Options<UserRevokeMyAccessTokenData>> => {
    const mutationOptions: UseMutationOptions<unknown, UserRevokeMyAccessTokenError, Options<UserRevokeMyAccessTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userRevokeMyAccessToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userListMyWebhooksQueryKey = (options?: Options<UserListMyWebhooksData>) => createQueryKey('userListMyWebhooks', options, false, ['User']);

/**
 * List webhooks for current user
 */
export const userListMyWebhooksOptions = (options?: Options<UserListMyWebhooksData>) => queryOptions<UserListMyWebhooksResponse, UserListMyWebhooksError, UserListMyWebhooksResponse, ReturnType<typeof userListMyWebhooksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userListMyWebhooks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userListMyWebhooksQueryKey(options)
});

/**
 * Create a webhook for current user
 */
export const userCreateMyWebhookMutation = (options?: Partial<Options<UserCreateMyWebhookData>>): UseMutationOptions<UserCreateMyWebhookResponse, UserCreateMyWebhookError, Options<UserCreateMyWebhookData>> => {
    const mutationOptions: UseMutationOptions<UserCreateMyWebhookResponse, UserCreateMyWebhookError, Options<UserCreateMyWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userCreateMyWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a webhook
 */
export const userDeleteMyWebhookMutation = (options?: Partial<Options<UserDeleteMyWebhookData>>): UseMutationOptions<unknown, UserDeleteMyWebhookError, Options<UserDeleteMyWebhookData>> => {
    const mutationOptions: UseMutationOptions<unknown, UserDeleteMyWebhookError, Options<UserDeleteMyWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userDeleteMyWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tagSuggestPromptForImageQueryKey = (options: Options<TagSuggestPromptForImageData>) => createQueryKey('tagSuggestPromptForImage', options, false, ['Tag']);

export const tagSuggestPromptForImageOptions = (options: Options<TagSuggestPromptForImageData>) => queryOptions<TagSuggestPromptForImageResponse, TagSuggestPromptForImageError, TagSuggestPromptForImageResponse, ReturnType<typeof tagSuggestPromptForImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tagSuggestPromptForImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tagSuggestPromptForImageQueryKey(options)
});

export const taskGetByIdQueryKey = (options: Options<TaskGetByIdData>) => createQueryKey('taskGetById', options, false, ['Task']);

/**
 * Get a task by ID
 *
 * Returns the status and basic outputs of a task owned by the current user. Heavy fields (parameters, ...) are opt-in via with_<field>=true query params.
 */
export const taskGetByIdOptions = (options: Options<TaskGetByIdData>) => queryOptions<TaskGetByIdResponse, TaskGetByIdError, TaskGetByIdResponse, ReturnType<typeof taskGetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await taskGetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: taskGetByIdQueryKey(options)
});

/**
 * Cancel a long-running task
 *
 * Cancels and refunds a task owned by the current user that has been running for at least 24 hours.
 */
export const taskCancelRunningTaskMutation = (options?: Partial<Options<TaskCancelRunningTaskData>>): UseMutationOptions<TaskCancelRunningTaskResponse, TaskCancelRunningTaskError, Options<TaskCancelRunningTaskData>> => {
    const mutationOptions: UseMutationOptions<TaskCancelRunningTaskResponse, TaskCancelRunningTaskError, Options<TaskCancelRunningTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await taskCancelRunningTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const taskPredictWaitTimeQueryKey = (options: Options<TaskPredictWaitTimeData>) => createQueryKey('taskPredictWaitTime', options, false, ['Task']);

/**
 * Predict task wait time
 *
 * Returns an estimated wait time for a generation task of the given priority and target model. Provide either a generationModelId (latest version is resolved) or a modelVersionId (used directly, matching the enqueue generation task flow).
 */
export const taskPredictWaitTimeOptions = (options: Options<TaskPredictWaitTimeData>) => queryOptions<TaskPredictWaitTimeResponse, TaskPredictWaitTimeError, TaskPredictWaitTimeResponse, ReturnType<typeof taskPredictWaitTimeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await taskPredictWaitTime({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: taskPredictWaitTimeQueryKey(options)
});

/**
 * Acquire a pre-generated task
 *
 * Claims a pre-generated task for the current user. Tackled by tackId on the new path; falls back to the legacy TAG pool while migration is in flight.
 */
export const taskAcquirePreGeneratedMutation = (options?: Partial<Options<TaskAcquirePreGeneratedData>>): UseMutationOptions<TaskAcquirePreGeneratedResponse, TaskAcquirePreGeneratedError, Options<TaskAcquirePreGeneratedData>> => {
    const mutationOptions: UseMutationOptions<TaskAcquirePreGeneratedResponse, TaskAcquirePreGeneratedError, Options<TaskAcquirePreGeneratedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await taskAcquirePreGenerated({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const modelExperimentSessionGetExpSessionQueryKey = (options: Options<ModelExperimentSessionGetExpSessionData>) => createQueryKey('modelExperimentSessionGetExpSession', options, false, ['Model Experiment']);

/**
 * Get the A/B model experiment session for a task
 *
 * Returns the experiment session attached to a multi-job root task, with images arranged per the session's display order. Returns 404 when the task has no associated session.
 */
export const modelExperimentSessionGetExpSessionOptions = (options: Options<ModelExperimentSessionGetExpSessionData>) => queryOptions<ModelExperimentSessionGetExpSessionResponse, ModelExperimentSessionGetExpSessionError, ModelExperimentSessionGetExpSessionResponse, ReturnType<typeof modelExperimentSessionGetExpSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelExperimentSessionGetExpSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelExperimentSessionGetExpSessionQueryKey(options)
});

/**
 * Submit the user preference for an A/B experiment session
 *
 * Records the user choice and resolves the session.
 */
export const modelExperimentSessionSubmitPreferenceMutation = (options?: Partial<Options<ModelExperimentSessionSubmitPreferenceData>>): UseMutationOptions<ModelExperimentSessionSubmitPreferenceResponse, ModelExperimentSessionSubmitPreferenceError, Options<ModelExperimentSessionSubmitPreferenceData>> => {
    const mutationOptions: UseMutationOptions<ModelExperimentSessionSubmitPreferenceResponse, ModelExperimentSessionSubmitPreferenceError, Options<ModelExperimentSessionSubmitPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await modelExperimentSessionSubmitPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const testOpsCreateTestUserMutation = (options?: Partial<Options<TestOpsCreateTestUserData>>): UseMutationOptions<TestOpsCreateTestUserResponse, TestOpsCreateTestUserError, Options<TestOpsCreateTestUserData>> => {
    const mutationOptions: UseMutationOptions<TestOpsCreateTestUserResponse, TestOpsCreateTestUserError, Options<TestOpsCreateTestUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testOpsCreateTestUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tackCuratedArtworksQueryKey = (options: Options<TackCuratedArtworksData>) => createQueryKey('tackCuratedArtworks', options, false, ['Tack']);

/**
 * Get curated artwork feed for a tack
 */
export const tackCuratedArtworksOptions = (options: Options<TackCuratedArtworksData>) => queryOptions<TackCuratedArtworksResponse, TackCuratedArtworksError, TackCuratedArtworksResponse, ReturnType<typeof tackCuratedArtworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tackCuratedArtworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tackCuratedArtworksQueryKey(options)
});

export const tackCuratedArtworksInfiniteQueryKey = (options: Options<TackCuratedArtworksData>): QueryKey<Options<TackCuratedArtworksData>> => createQueryKey('tackCuratedArtworks', options, true);

/**
 * Get curated artwork feed for a tack
 */
export const tackCuratedArtworksInfiniteOptions = (options: Options<TackCuratedArtworksData>) => infiniteQueryOptions<TackCuratedArtworksResponse, TackCuratedArtworksError, InfiniteData<TackCuratedArtworksResponse>, QueryKey<Options<TackCuratedArtworksData>>, number | Pick<QueryKey<Options<TackCuratedArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<TackCuratedArtworksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await tackCuratedArtworks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tackCuratedArtworksInfiniteQueryKey(options)
});

export const tackGalleryQueryKey = (options?: Options<TackGalleryData>) => createQueryKey('tackGallery', options, false, ['Tack']);

/**
 * List trending IP/character tacks for gallery display
 *
 * Returns tacks in the `ip` and `character` categories that currently appear in the trending set, ordered by trending score descending (ties broken by tackId descending).
 */
export const tackGalleryOptions = (options?: Options<TackGalleryData>) => queryOptions<TackGalleryResponse, DefaultError, TackGalleryResponse, ReturnType<typeof tackGalleryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tackGallery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tackGalleryQueryKey(options)
});

export const tackTrendingQueryKey = (options?: Options<TackTrendingData>) => createQueryKey('tackTrending', options, false, ['Tack']);

/**
 * List trending tacks
 *
 * Returns trending tacks with page-based pagination. Use the `sort` param to control ordering: `trending` (default) sorts by weighted score, `weekly` by 7-day artwork count, `daily` by 24-hour artwork count.
 */
export const tackTrendingOptions = (options?: Options<TackTrendingData>) => queryOptions<TackTrendingResponse, DefaultError, TackTrendingResponse, ReturnType<typeof tackTrendingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tackTrending({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tackTrendingQueryKey(options)
});

export const tackTrendingInfiniteQueryKey = (options?: Options<TackTrendingData>): QueryKey<Options<TackTrendingData>> => createQueryKey('tackTrending', options, true);

/**
 * List trending tacks
 *
 * Returns trending tacks with page-based pagination. Use the `sort` param to control ordering: `trending` (default) sorts by weighted score, `weekly` by 7-day artwork count, `daily` by 24-hour artwork count.
 */
export const tackTrendingInfiniteOptions = (options?: Options<TackTrendingData>) => infiniteQueryOptions<TackTrendingResponse, DefaultError, InfiniteData<TackTrendingResponse>, QueryKey<Options<TackTrendingData>>, number | Pick<QueryKey<Options<TackTrendingData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<TackTrendingData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await tackTrending({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tackTrendingInfiniteQueryKey(options)
});

/**
 * Sync tack data from pixai-tack service
 *
 * Receives tack updates from pixai-tack, invalidates cache and updates Elasticsearch
 */
export const tackSyncFromPixaiTackMutation = (options?: Partial<Options<TackSyncFromPixaiTackData>>): UseMutationOptions<TackSyncFromPixaiTackResponse, TackSyncFromPixaiTackError, Options<TackSyncFromPixaiTackData>> => {
    const mutationOptions: UseMutationOptions<TackSyncFromPixaiTackResponse, TackSyncFromPixaiTackError, Options<TackSyncFromPixaiTackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tackSyncFromPixaiTack({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tackAutocompleteQueryKey = (options: Options<TackAutocompleteData>) => createQueryKey('tackAutocomplete', options, false, ['Tack']);

/**
 * Autocomplete tack search with CJK support
 *
 * Prefix + fuzzy search over TackTermUnion. Kana input is converted to romaji for CJK coverage.
 */
export const tackAutocompleteOptions = (options: Options<TackAutocompleteData>) => queryOptions<TackAutocompleteResponse, DefaultError, TackAutocompleteResponse, ReturnType<typeof tackAutocompleteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tackAutocomplete({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tackAutocompleteQueryKey(options)
});

export const tackBatchQueryKey = (options: Options<TackBatchData>) => createQueryKey('tackBatch', options, false, ['Tack']);

/**
 * Batch get tacks by IDs
 *
 * Returns tacks matching the given IDs, ordered to match the input `ids`. Each tack includes a small (avatar-sized) `thumbnailUrl` resolved server-side and a resolved `displayName` (user-language term → English term → `defaultName`; falls through to `defaultName` when `lang` is omitted). Unknown IDs are silently omitted. Capped at 100 IDs per request.
 */
export const tackBatchOptions = (options: Options<TackBatchData>) => queryOptions<TackBatchResponse, DefaultError, TackBatchResponse, ReturnType<typeof tackBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tackBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tackBatchQueryKey(options)
});

export const extraPackageBoostListMyBoostsQueryKey = (options?: Options<ExtraPackageBoostListMyBoostsData>) => createQueryKey('extraPackageBoostListMyBoosts', options, false, ['ExtraPackageBoost']);

export const extraPackageBoostListMyBoostsOptions = (options?: Options<ExtraPackageBoostListMyBoostsData>) => queryOptions<ExtraPackageBoostListMyBoostsResponse, DefaultError, ExtraPackageBoostListMyBoostsResponse, ReturnType<typeof extraPackageBoostListMyBoostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await extraPackageBoostListMyBoosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: extraPackageBoostListMyBoostsQueryKey(options)
});

export const extraPackageBoostListMyBoostsInfiniteQueryKey = (options?: Options<ExtraPackageBoostListMyBoostsData>): QueryKey<Options<ExtraPackageBoostListMyBoostsData>> => createQueryKey('extraPackageBoostListMyBoosts', options, true);

export const extraPackageBoostListMyBoostsInfiniteOptions = (options?: Options<ExtraPackageBoostListMyBoostsData>) => infiniteQueryOptions<ExtraPackageBoostListMyBoostsResponse, DefaultError, InfiniteData<ExtraPackageBoostListMyBoostsResponse>, QueryKey<Options<ExtraPackageBoostListMyBoostsData>>, string | Pick<QueryKey<Options<ExtraPackageBoostListMyBoostsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ExtraPackageBoostListMyBoostsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await extraPackageBoostListMyBoosts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: extraPackageBoostListMyBoostsInfiniteQueryKey(options)
});

export const extraPackageBoostGetByCodeQueryKey = (options: Options<ExtraPackageBoostGetByCodeData>) => createQueryKey('extraPackageBoostGetByCode', options, false, ['ExtraPackageBoost']);

export const extraPackageBoostGetByCodeOptions = (options: Options<ExtraPackageBoostGetByCodeData>) => queryOptions<ExtraPackageBoostGetByCodeResponse, ExtraPackageBoostGetByCodeError, ExtraPackageBoostGetByCodeResponse, ReturnType<typeof extraPackageBoostGetByCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await extraPackageBoostGetByCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: extraPackageBoostGetByCodeQueryKey(options)
});

export const extraPackageListQueryKey = (options?: Options<ExtraPackageListData>) => createQueryKey('extraPackageList', options, false, ['ExtraPackage']);

/**
 * List purchasable extra-package SKUs for the caller
 */
export const extraPackageListOptions = (options?: Options<ExtraPackageListData>) => queryOptions<ExtraPackageListResponse, DefaultError, ExtraPackageListResponse, ReturnType<typeof extraPackageListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await extraPackageList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: extraPackageListQueryKey(options)
});

export const extraPackageGetQueryKey = (options: Options<ExtraPackageGetData>) => createQueryKey('extraPackageGet', options, false, ['ExtraPackage']);

/**
 * Get a single extra-package SKU
 */
export const extraPackageGetOptions = (options: Options<ExtraPackageGetData>) => queryOptions<ExtraPackageGetResponse, ExtraPackageGetError, ExtraPackageGetResponse, ReturnType<typeof extraPackageGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await extraPackageGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: extraPackageGetQueryKey(options)
});

/**
 * Create an order + dispatch payment for an extra-package SKU
 */
export const extraPackagePurchaseMutation = (options?: Partial<Options<ExtraPackagePurchaseData>>): UseMutationOptions<ExtraPackagePurchaseResponse, ExtraPackagePurchaseError, Options<ExtraPackagePurchaseData>> => {
    const mutationOptions: UseMutationOptions<ExtraPackagePurchaseResponse, ExtraPackagePurchaseError, Options<ExtraPackagePurchaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extraPackagePurchase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm extra-package payment for web providers
 */
export const extraPackageConfirmWebMutation = (options?: Partial<Options<ExtraPackageConfirmWebData>>): UseMutationOptions<ExtraPackageConfirmWebResponse, ExtraPackageConfirmWebError, Options<ExtraPackageConfirmWebData>> => {
    const mutationOptions: UseMutationOptions<ExtraPackageConfirmWebResponse, ExtraPackageConfirmWebError, Options<ExtraPackageConfirmWebData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extraPackageConfirmWeb({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm extra-package payment for Apple IAP
 */
export const extraPackageConfirmAppleMutation = (options?: Partial<Options<ExtraPackageConfirmAppleData>>): UseMutationOptions<ExtraPackageConfirmAppleResponse, ExtraPackageConfirmAppleError, Options<ExtraPackageConfirmAppleData>> => {
    const mutationOptions: UseMutationOptions<ExtraPackageConfirmAppleResponse, ExtraPackageConfirmAppleError, Options<ExtraPackageConfirmAppleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extraPackageConfirmApple({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm extra-package payment for Google IAP
 */
export const extraPackageConfirmGoogleMutation = (options?: Partial<Options<ExtraPackageConfirmGoogleData>>): UseMutationOptions<ExtraPackageConfirmGoogleResponse, ExtraPackageConfirmGoogleError, Options<ExtraPackageConfirmGoogleData>> => {
    const mutationOptions: UseMutationOptions<ExtraPackageConfirmGoogleResponse, ExtraPackageConfirmGoogleError, Options<ExtraPackageConfirmGoogleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extraPackageConfirmGoogle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const extraPackageListGroupsQueryKey = (options?: Options<ExtraPackageListGroupsData>) => createQueryKey('extraPackageListGroups', options, false, ['ExtraPackage']);

/**
 * List active extra-package groups
 */
export const extraPackageListGroupsOptions = (options?: Options<ExtraPackageListGroupsData>) => queryOptions<ExtraPackageListGroupsResponse, DefaultError, ExtraPackageListGroupsResponse, ReturnType<typeof extraPackageListGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await extraPackageListGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: extraPackageListGroupsQueryKey(options)
});

export const orderGetByIdQueryKey = (options: Options<OrderGetByIdData>) => createQueryKey('orderGetById', options, false, ['Order']);

/**
 * Get order by ID
 */
export const orderGetByIdOptions = (options: Options<OrderGetByIdData>) => queryOptions<OrderGetByIdResponse, OrderGetByIdError, OrderGetByIdResponse, ReturnType<typeof orderGetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orderGetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orderGetByIdQueryKey(options)
});

export const paymentGetPaymentMethodsQueryKey = (options?: Options<PaymentGetPaymentMethodsData>) => createQueryKey('paymentGetPaymentMethods', options, false, ['Payment']);

export const paymentGetPaymentMethodsOptions = (options?: Options<PaymentGetPaymentMethodsData>) => queryOptions<PaymentGetPaymentMethodsResponse, PaymentGetPaymentMethodsError, PaymentGetPaymentMethodsResponse, ReturnType<typeof paymentGetPaymentMethodsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await paymentGetPaymentMethods({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: paymentGetPaymentMethodsQueryKey(options)
});

/**
 * Save filtered image result as a completed generation task
 */
export const imageFilterApplyFilterMutation = (options?: Partial<Options<ImageFilterApplyFilterData>>): UseMutationOptions<ImageFilterApplyFilterResponse, ImageFilterApplyFilterError, Options<ImageFilterApplyFilterData>> => {
    const mutationOptions: UseMutationOptions<ImageFilterApplyFilterResponse, ImageFilterApplyFilterError, Options<ImageFilterApplyFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await imageFilterApplyFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uaNewbiePackGetSnapshotQueryKey = (options?: Options<UaNewbiePackGetSnapshotData>) => createQueryKey('uaNewbiePackGetSnapshot', options, false, ['PaymentEvents']);

/**
 * Get newbie-pack campaign snapshot for current user
 */
export const uaNewbiePackGetSnapshotOptions = (options?: Options<UaNewbiePackGetSnapshotData>) => queryOptions<UaNewbiePackGetSnapshotResponse, UaNewbiePackGetSnapshotError, UaNewbiePackGetSnapshotResponse, ReturnType<typeof uaNewbiePackGetSnapshotQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await uaNewbiePackGetSnapshot({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: uaNewbiePackGetSnapshotQueryKey(options)
});

/**
 * Mark newbie-pack Aha popup as shown for current user account
 */
export const uaNewbiePackMarkAhaShownMutation = (options?: Partial<Options<UaNewbiePackMarkAhaShownData>>): UseMutationOptions<UaNewbiePackMarkAhaShownResponse, UaNewbiePackMarkAhaShownError, Options<UaNewbiePackMarkAhaShownData>> => {
    const mutationOptions: UseMutationOptions<UaNewbiePackMarkAhaShownResponse, UaNewbiePackMarkAhaShownError, Options<UaNewbiePackMarkAhaShownData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uaNewbiePackMarkAhaShown({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userDecorationRelationGetUserDecorationRelationQueryKey = (options: Options<UserDecorationRelationGetUserDecorationRelationData>) => createQueryKey('userDecorationRelationGetUserDecorationRelation', options, false, ['UserDecorationRelation']);

/**
 * Get user decoration relation by ID
 */
export const userDecorationRelationGetUserDecorationRelationOptions = (options: Options<UserDecorationRelationGetUserDecorationRelationData>) => queryOptions<UserDecorationRelationGetUserDecorationRelationResponse, UserDecorationRelationGetUserDecorationRelationError, UserDecorationRelationGetUserDecorationRelationResponse, ReturnType<typeof userDecorationRelationGetUserDecorationRelationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userDecorationRelationGetUserDecorationRelation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userDecorationRelationGetUserDecorationRelationQueryKey(options)
});

/**
 * Update user decoration relation
 */
export const userDecorationRelationUpdateUserDecorationRelationMutation = (options?: Partial<Options<UserDecorationRelationUpdateUserDecorationRelationData>>): UseMutationOptions<UserDecorationRelationUpdateUserDecorationRelationResponse, UserDecorationRelationUpdateUserDecorationRelationError, Options<UserDecorationRelationUpdateUserDecorationRelationData>> => {
    const mutationOptions: UseMutationOptions<UserDecorationRelationUpdateUserDecorationRelationResponse, UserDecorationRelationUpdateUserDecorationRelationError, Options<UserDecorationRelationUpdateUserDecorationRelationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userDecorationRelationUpdateUserDecorationRelation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userOrderEmailListQueryKey = (options?: Options<UserOrderEmailListData>) => createQueryKey('userOrderEmailList', options, false, ['UserOrderEmail']);

/**
 * List the authenticated user's recently used billing emails
 *
 * Returns distinct billing emails the user has supplied at onerway checkout, most-recent first. Used to prefill the email field on the checkout form. The same email may have been entered multiple times; only the latest occurrence per email is returned.
 */
export const userOrderEmailListOptions = (options?: Options<UserOrderEmailListData>) => queryOptions<UserOrderEmailListResponse, UserOrderEmailListError, UserOrderEmailListResponse, ReturnType<typeof userOrderEmailListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userOrderEmailList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userOrderEmailListQueryKey(options)
});

export const bannerListQueryKey = (options?: Options<BannerListData>) => createQueryKey('bannerList', options, false, ['Banner']);

/**
 * List active home-banner items
 */
export const bannerListOptions = (options?: Options<BannerListData>) => queryOptions<BannerListResponse, DefaultError, BannerListResponse, ReturnType<typeof bannerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bannerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bannerListQueryKey(options)
});

export const campaignAdsListQueryKey = (options?: Options<CampaignAdsListData>) => createQueryKey('campaignAdsList', options, false, ['CampaignAds']);

/**
 * List campaign ads for a language and category
 *
 * Returns the campaign banner / ad entries configured for the given category, falling back to English if the requested language is not present in the YAML config.
 */
export const campaignAdsListOptions = (options?: Options<CampaignAdsListData>) => queryOptions<CampaignAdsListResponse, DefaultError, CampaignAdsListResponse, ReturnType<typeof campaignAdsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignAdsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignAdsListQueryKey(options)
});

export const claimListQueryKey = (options?: Options<ClaimListData>) => createQueryKey('claimList', options, false, ['Claim']);

/**
 * List all claimable rewards
 *
 * Returns all available claim types with their current status for the authenticated user.
 */
export const claimListOptions = (options?: Options<ClaimListData>) => queryOptions<ClaimListResponse, ClaimListError, ClaimListResponse, ReturnType<typeof claimListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await claimList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: claimListQueryKey(options)
});

export const claimGetQueryKey = (options: Options<ClaimGetData>) => createQueryKey('claimGet', options, false, ['Claim']);

/**
 * Get claim info by id
 *
 * Returns the claim status for a specific claim type (e.g., pixai-daily-credits, agent-stamina-daily).
 */
export const claimGetOptions = (options: Options<ClaimGetData>) => queryOptions<ClaimGetResponse, ClaimGetError, ClaimGetResponse, ReturnType<typeof claimGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await claimGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: claimGetQueryKey(options)
});

/**
 * Claim a reward
 *
 * Claims the specified reward if available. Returns the updated claim status after claiming.
 */
export const claimClaimMutation = (options?: Partial<Options<ClaimClaimData>>): UseMutationOptions<ClaimClaimResponse, ClaimClaimError, Options<ClaimClaimData>> => {
    const mutationOptions: UseMutationOptions<ClaimClaimResponse, ClaimClaimError, Options<ClaimClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await claimClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contestListQueryKey = (options?: Options<ContestListData>) => createQueryKey('contestList', options, false, ['Contest']);

/**
 * List contests with pagination and filters
 */
export const contestListOptions = (options?: Options<ContestListData>) => queryOptions<ContestListResponse, DefaultError, ContestListResponse, ReturnType<typeof contestListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestListQueryKey(options)
});

export const contestListInfiniteQueryKey = (options?: Options<ContestListData>): QueryKey<Options<ContestListData>> => createQueryKey('contestList', options, true);

/**
 * List contests with pagination and filters
 */
export const contestListInfiniteOptions = (options?: Options<ContestListData>) => infiniteQueryOptions<ContestListResponse, DefaultError, InfiniteData<ContestListResponse>, QueryKey<Options<ContestListData>>, string | Pick<QueryKey<Options<ContestListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ContestListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await contestList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestListInfiniteQueryKey(options)
});

export const contestV2ListQueryKey = (options?: Options<ContestV2ListData>) => createQueryKey('contestV2List', options, false, ['Contest V2']);

/**
 * List public contests
 */
export const contestV2ListOptions = (options?: Options<ContestV2ListData>) => queryOptions<ContestV2ListResponse, DefaultError, ContestV2ListResponse, ReturnType<typeof contestV2ListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2List({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListQueryKey(options)
});

export const contestV2ListInfiniteQueryKey = (options?: Options<ContestV2ListData>): QueryKey<Options<ContestV2ListData>> => createQueryKey('contestV2List', options, true);

/**
 * List public contests
 */
export const contestV2ListInfiniteOptions = (options?: Options<ContestV2ListData>) => infiniteQueryOptions<ContestV2ListResponse, DefaultError, InfiniteData<ContestV2ListResponse>, QueryKey<Options<ContestV2ListData>>, number | Pick<QueryKey<Options<ContestV2ListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ContestV2ListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await contestV2List({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListInfiniteQueryKey(options)
});

export const contestV2ListBannerQueryKey = (options?: Options<ContestV2ListBannerData>) => createQueryKey('contestV2ListBanner', options, false, ['Contest V2']);

/**
 * List active contest banners
 */
export const contestV2ListBannerOptions = (options?: Options<ContestV2ListBannerData>) => queryOptions<ContestV2ListBannerResponse, DefaultError, ContestV2ListBannerResponse, ReturnType<typeof contestV2ListBannerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2ListBanner({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListBannerQueryKey(options)
});

export const contestV2CreateCheckQueryKey = (options?: Options<ContestV2CreateCheckData>) => createQueryKey('contestV2CreateCheck', options, false, ['Contest V2']);

/**
 * Check whether current user is eligible to create a contest
 *
 * Lightweight pre-flight for the contest create entry. Always 200. reasons collects every failed check, so the FE can render all missing requirements at once. Codes come from src/constants/errors.ts.
 */
export const contestV2CreateCheckOptions = (options?: Options<ContestV2CreateCheckData>) => queryOptions<ContestV2CreateCheckResponse, DefaultError, ContestV2CreateCheckResponse, ReturnType<typeof contestV2CreateCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2CreateCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2CreateCheckQueryKey(options)
});

/**
 * Create a community contest
 */
export const contestV2CreateMutation = (options?: Partial<Options<ContestV2CreateData>>): UseMutationOptions<ContestV2CreateResponse, ContestV2CreateError, Options<ContestV2CreateData>> => {
    const mutationOptions: UseMutationOptions<ContestV2CreateResponse, ContestV2CreateError, Options<ContestV2CreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contestV2Create({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contestV2ListFollowByUserQueryKey = (options: Options<ContestV2ListFollowByUserData>) => createQueryKey('contestV2ListFollowByUser', options, false, ['Contest V2']);

/**
 * List contests followed by a user
 *
 * Ordered by the listed user follow time desc. followAt belongs to the current viewer (null when anonymous or not following). When the viewer is the listed user or an admin, pending contests are included; other viewers see published contests only. Cancelled and draft contests are always hidden.
 */
export const contestV2ListFollowByUserOptions = (options: Options<ContestV2ListFollowByUserData>) => queryOptions<ContestV2ListFollowByUserResponse, DefaultError, ContestV2ListFollowByUserResponse, ReturnType<typeof contestV2ListFollowByUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2ListFollowByUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListFollowByUserQueryKey(options)
});

export const contestV2ListFollowByUserInfiniteQueryKey = (options: Options<ContestV2ListFollowByUserData>): QueryKey<Options<ContestV2ListFollowByUserData>> => createQueryKey('contestV2ListFollowByUser', options, true);

/**
 * List contests followed by a user
 *
 * Ordered by the listed user follow time desc. followAt belongs to the current viewer (null when anonymous or not following). When the viewer is the listed user or an admin, pending contests are included; other viewers see published contests only. Cancelled and draft contests are always hidden.
 */
export const contestV2ListFollowByUserInfiniteOptions = (options: Options<ContestV2ListFollowByUserData>) => infiniteQueryOptions<ContestV2ListFollowByUserResponse, DefaultError, InfiniteData<ContestV2ListFollowByUserResponse>, QueryKey<Options<ContestV2ListFollowByUserData>>, number | Pick<QueryKey<Options<ContestV2ListFollowByUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ContestV2ListFollowByUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await contestV2ListFollowByUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListFollowByUserInfiniteQueryKey(options)
});

export const contestV2ListCreatedByUserQueryKey = (options: Options<ContestV2ListCreatedByUserData>) => createQueryKey('contestV2ListCreatedByUser', options, false, ['Contest V2']);

/**
 * List contests created by a user
 *
 * Ordered by creation time desc (id desc, since contest ids are snowflake-based). When the viewer is the listed user or an admin, every lifecycleStatus is returned; other viewers see published contests only. Visibility is enforced server-side; clients cannot filter by lifecycleStatus.
 */
export const contestV2ListCreatedByUserOptions = (options: Options<ContestV2ListCreatedByUserData>) => queryOptions<ContestV2ListCreatedByUserResponse, DefaultError, ContestV2ListCreatedByUserResponse, ReturnType<typeof contestV2ListCreatedByUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2ListCreatedByUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListCreatedByUserQueryKey(options)
});

export const contestV2ListCreatedByUserInfiniteQueryKey = (options: Options<ContestV2ListCreatedByUserData>): QueryKey<Options<ContestV2ListCreatedByUserData>> => createQueryKey('contestV2ListCreatedByUser', options, true);

/**
 * List contests created by a user
 *
 * Ordered by creation time desc (id desc, since contest ids are snowflake-based). When the viewer is the listed user or an admin, every lifecycleStatus is returned; other viewers see published contests only. Visibility is enforced server-side; clients cannot filter by lifecycleStatus.
 */
export const contestV2ListCreatedByUserInfiniteOptions = (options: Options<ContestV2ListCreatedByUserData>) => infiniteQueryOptions<ContestV2ListCreatedByUserResponse, DefaultError, InfiniteData<ContestV2ListCreatedByUserResponse>, QueryKey<Options<ContestV2ListCreatedByUserData>>, number | Pick<QueryKey<Options<ContestV2ListCreatedByUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ContestV2ListCreatedByUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await contestV2ListCreatedByUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListCreatedByUserInfiniteQueryKey(options)
});

export const contestV2GetBySlugQueryKey = (options: Options<ContestV2GetBySlugData>) => createQueryKey('contestV2GetBySlug', options, false, ['Contest V2']);

/**
 * Get contest detail by slug
 */
export const contestV2GetBySlugOptions = (options: Options<ContestV2GetBySlugData>) => queryOptions<ContestV2GetBySlugResponse, ContestV2GetBySlugError, ContestV2GetBySlugResponse, ReturnType<typeof contestV2GetBySlugQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2GetBySlug({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2GetBySlugQueryKey(options)
});

export const contestV2ListArtworkQueryKey = (options: Options<ContestV2ListArtworkData>) => createQueryKey('contestV2ListArtwork', options, false, ['Contest V2']);

/**
 * List artworks submitted to a contest
 */
export const contestV2ListArtworkOptions = (options: Options<ContestV2ListArtworkData>) => queryOptions<ContestV2ListArtworkResponse, ContestV2ListArtworkError, ContestV2ListArtworkResponse, ReturnType<typeof contestV2ListArtworkQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2ListArtwork({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListArtworkQueryKey(options)
});

export const contestV2ListArtworkInfiniteQueryKey = (options: Options<ContestV2ListArtworkData>): QueryKey<Options<ContestV2ListArtworkData>> => createQueryKey('contestV2ListArtwork', options, true);

/**
 * List artworks submitted to a contest
 */
export const contestV2ListArtworkInfiniteOptions = (options: Options<ContestV2ListArtworkData>) => infiniteQueryOptions<ContestV2ListArtworkResponse, ContestV2ListArtworkError, InfiniteData<ContestV2ListArtworkResponse>, QueryKey<Options<ContestV2ListArtworkData>>, number | Pick<QueryKey<Options<ContestV2ListArtworkData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ContestV2ListArtworkData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await contestV2ListArtwork({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListArtworkInfiniteQueryKey(options)
});

/**
 * Submit an artwork to a contest
 */
export const contestV2SubmitArtworkMutation = (options?: Partial<Options<ContestV2SubmitArtworkData>>): UseMutationOptions<ContestV2SubmitArtworkResponse, ContestV2SubmitArtworkError, Options<ContestV2SubmitArtworkData>> => {
    const mutationOptions: UseMutationOptions<ContestV2SubmitArtworkResponse, ContestV2SubmitArtworkError, Options<ContestV2SubmitArtworkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contestV2SubmitArtwork({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contestV2ListArtworkByUserQueryKey = (options: Options<ContestV2ListArtworkByUserData>) => createQueryKey('contestV2ListArtworkByUser', options, false, ['Contest V2']);

/**
 * List a user's submissions to a contest
 */
export const contestV2ListArtworkByUserOptions = (options: Options<ContestV2ListArtworkByUserData>) => queryOptions<ContestV2ListArtworkByUserResponse, ContestV2ListArtworkByUserError, ContestV2ListArtworkByUserResponse, ReturnType<typeof contestV2ListArtworkByUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2ListArtworkByUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListArtworkByUserQueryKey(options)
});

export const contestV2ListWinnersQueryKey = (options: Options<ContestV2ListWinnersData>) => createQueryKey('contestV2ListWinners', options, false, ['Contest V2']);

/**
 * List awarded winners of a contest in rank order
 *
 * Returns [] while the contest is still pre-selection (rewardStatus null or pending_selection). Once winners are selected, returns artworks ordered by rank ascending; card.contest.entry carries rank / prizeAmount / source / submittedAt.
 */
export const contestV2ListWinnersOptions = (options: Options<ContestV2ListWinnersData>) => queryOptions<ContestV2ListWinnersResponse, ContestV2ListWinnersError, ContestV2ListWinnersResponse, ReturnType<typeof contestV2ListWinnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contestV2ListWinners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contestV2ListWinnersQueryKey(options)
});

/**
 * Follow a contest
 */
export const contestV2FollowMutation = (options?: Partial<Options<ContestV2FollowData>>): UseMutationOptions<ContestV2FollowResponse, ContestV2FollowError, Options<ContestV2FollowData>> => {
    const mutationOptions: UseMutationOptions<ContestV2FollowResponse, ContestV2FollowError, Options<ContestV2FollowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contestV2Follow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unfollow a contest
 */
export const contestV2UnfollowMutation = (options?: Partial<Options<ContestV2UnfollowData>>): UseMutationOptions<ContestV2UnfollowResponse, ContestV2UnfollowError, Options<ContestV2UnfollowData>> => {
    const mutationOptions: UseMutationOptions<ContestV2UnfollowResponse, ContestV2UnfollowError, Options<ContestV2UnfollowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contestV2Unfollow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generationModelGetMyModelPermissionQueryKey = (options: Options<GenerationModelGetMyModelPermissionData>) => createQueryKey('generationModelGetMyModelPermission', options, false, ['GenerationModel']);

/**
 * Get current user permissions for a model
 */
export const generationModelGetMyModelPermissionOptions = (options: Options<GenerationModelGetMyModelPermissionData>) => queryOptions<GenerationModelGetMyModelPermissionResponse, DefaultError, GenerationModelGetMyModelPermissionResponse, ReturnType<typeof generationModelGetMyModelPermissionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationModelGetMyModelPermission({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetMyModelPermissionQueryKey(options)
});

export const generationModelGetStyleKeysQueryKey = (options: Options<GenerationModelGetStyleKeysData>) => createQueryKey('generationModelGetStyleKeys', options, false, ['GenerationModel']);

/**
 * Get style keys for a model version
 */
export const generationModelGetStyleKeysOptions = (options: Options<GenerationModelGetStyleKeysData>) => queryOptions<GenerationModelGetStyleKeysResponse, GenerationModelGetStyleKeysError, GenerationModelGetStyleKeysResponse, ReturnType<typeof generationModelGetStyleKeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationModelGetStyleKeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetStyleKeysQueryKey(options)
});

export const generationModelGetFeaturesByModelVersionIdQueryKey = (options: Options<GenerationModelGetFeaturesByModelVersionIdData>) => createQueryKey('generationModelGetFeaturesByModelVersionId', options, false, ['GenerationModel']);

/**
 * Get features for a model
 */
export const generationModelGetFeaturesByModelVersionIdOptions = (options: Options<GenerationModelGetFeaturesByModelVersionIdData>) => queryOptions<GenerationModelGetFeaturesByModelVersionIdResponse, GenerationModelGetFeaturesByModelVersionIdError, GenerationModelGetFeaturesByModelVersionIdResponse, ReturnType<typeof generationModelGetFeaturesByModelVersionIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationModelGetFeaturesByModelVersionId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetFeaturesByModelVersionIdQueryKey(options)
});

export const generationModelGetInferenceProfilesQueryKey = (options: Options<GenerationModelGetInferenceProfilesData>) => createQueryKey('generationModelGetInferenceProfiles', options, false, ['GenerationModel']);

/**
 * Get inference profiles for a model version
 */
export const generationModelGetInferenceProfilesOptions = (options: Options<GenerationModelGetInferenceProfilesData>) => queryOptions<GenerationModelGetInferenceProfilesResponse, GenerationModelGetInferenceProfilesError, GenerationModelGetInferenceProfilesResponse, ReturnType<typeof generationModelGetInferenceProfilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationModelGetInferenceProfiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetInferenceProfilesQueryKey(options)
});

export const generationModelGetSizeConfigQueryKey = (options: Options<GenerationModelGetSizeConfigData>) => createQueryKey('generationModelGetSizeConfig', options, false, ['GenerationModel']);

/**
 * Get size configuration for a model version
 */
export const generationModelGetSizeConfigOptions = (options: Options<GenerationModelGetSizeConfigData>) => queryOptions<GenerationModelGetSizeConfigResponse, GenerationModelGetSizeConfigError, GenerationModelGetSizeConfigResponse, ReturnType<typeof generationModelGetSizeConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationModelGetSizeConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetSizeConfigQueryKey(options)
});

export const generationModelGetTrendingArtworksByModelQueryKey = (options: Options<GenerationModelGetTrendingArtworksByModelData>) => createQueryKey('generationModelGetTrendingArtworksByModel', options, false, ['GenerationModel']);

/**
 * Get trending artworks for a generation model
 *
 * Returns trending public artworks generated with the given model, ranked by the `trending1` ES function-score (time-decay + log-scaled likes + quality signals + randomness — the same ranking the web app's "Trending" UI option resolves to via the GraphQL `feed: "trending1"` path). Distinct from `/most-liked`, which sorts by raw all-time like count.
 */
export const generationModelGetTrendingArtworksByModelOptions = (options: Options<GenerationModelGetTrendingArtworksByModelData>) => queryOptions<GenerationModelGetTrendingArtworksByModelResponse, GenerationModelGetTrendingArtworksByModelError, GenerationModelGetTrendingArtworksByModelResponse, ReturnType<typeof generationModelGetTrendingArtworksByModelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationModelGetTrendingArtworksByModel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetTrendingArtworksByModelQueryKey(options)
});

export const generationModelGetTrendingArtworksByModelInfiniteQueryKey = (options: Options<GenerationModelGetTrendingArtworksByModelData>): QueryKey<Options<GenerationModelGetTrendingArtworksByModelData>> => createQueryKey('generationModelGetTrendingArtworksByModel', options, true);

/**
 * Get trending artworks for a generation model
 *
 * Returns trending public artworks generated with the given model, ranked by the `trending1` ES function-score (time-decay + log-scaled likes + quality signals + randomness — the same ranking the web app's "Trending" UI option resolves to via the GraphQL `feed: "trending1"` path). Distinct from `/most-liked`, which sorts by raw all-time like count.
 */
export const generationModelGetTrendingArtworksByModelInfiniteOptions = (options: Options<GenerationModelGetTrendingArtworksByModelData>) => infiniteQueryOptions<GenerationModelGetTrendingArtworksByModelResponse, GenerationModelGetTrendingArtworksByModelError, InfiniteData<GenerationModelGetTrendingArtworksByModelResponse>, QueryKey<Options<GenerationModelGetTrendingArtworksByModelData>>, string | Pick<QueryKey<Options<GenerationModelGetTrendingArtworksByModelData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GenerationModelGetTrendingArtworksByModelData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await generationModelGetTrendingArtworksByModel({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetTrendingArtworksByModelInfiniteQueryKey(options)
});

export const generationModelGetLatestArtworksByModelQueryKey = (options: Options<GenerationModelGetLatestArtworksByModelData>) => createQueryKey('generationModelGetLatestArtworksByModel', options, false, ['GenerationModel']);

/**
 * Get latest artworks for a generation model
 *
 * Returns the newest public artworks generated with the given model, ordered by `createdAt` descending. Same view-permission gate, type-default mirroring, and output shape as `/trending`; only the orderBy differs.
 */
export const generationModelGetLatestArtworksByModelOptions = (options: Options<GenerationModelGetLatestArtworksByModelData>) => queryOptions<GenerationModelGetLatestArtworksByModelResponse, GenerationModelGetLatestArtworksByModelError, GenerationModelGetLatestArtworksByModelResponse, ReturnType<typeof generationModelGetLatestArtworksByModelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationModelGetLatestArtworksByModel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetLatestArtworksByModelQueryKey(options)
});

export const generationModelGetLatestArtworksByModelInfiniteQueryKey = (options: Options<GenerationModelGetLatestArtworksByModelData>): QueryKey<Options<GenerationModelGetLatestArtworksByModelData>> => createQueryKey('generationModelGetLatestArtworksByModel', options, true);

/**
 * Get latest artworks for a generation model
 *
 * Returns the newest public artworks generated with the given model, ordered by `createdAt` descending. Same view-permission gate, type-default mirroring, and output shape as `/trending`; only the orderBy differs.
 */
export const generationModelGetLatestArtworksByModelInfiniteOptions = (options: Options<GenerationModelGetLatestArtworksByModelData>) => infiniteQueryOptions<GenerationModelGetLatestArtworksByModelResponse, GenerationModelGetLatestArtworksByModelError, InfiniteData<GenerationModelGetLatestArtworksByModelResponse>, QueryKey<Options<GenerationModelGetLatestArtworksByModelData>>, string | Pick<QueryKey<Options<GenerationModelGetLatestArtworksByModelData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GenerationModelGetLatestArtworksByModelData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await generationModelGetLatestArtworksByModel({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetLatestArtworksByModelInfiniteQueryKey(options)
});

export const generationModelGetMostLikedArtworksByModelQueryKey = (options: Options<GenerationModelGetMostLikedArtworksByModelData>) => createQueryKey('generationModelGetMostLikedArtworksByModel', options, false, ['GenerationModel']);

/**
 * Get most-liked artworks for a generation model
 *
 * Returns public artworks generated with the given model, ordered by raw all-time `likedCount` descending. Mirrors the GraphQL `artworks(loraId, orderBy: "-markInfo.likedCount")` query the web app uses for the "Most Liked" UI option. Distinct from `/trending`, which uses the `trending1` function-score ranking.
 */
export const generationModelGetMostLikedArtworksByModelOptions = (options: Options<GenerationModelGetMostLikedArtworksByModelData>) => queryOptions<GenerationModelGetMostLikedArtworksByModelResponse, GenerationModelGetMostLikedArtworksByModelError, GenerationModelGetMostLikedArtworksByModelResponse, ReturnType<typeof generationModelGetMostLikedArtworksByModelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationModelGetMostLikedArtworksByModel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetMostLikedArtworksByModelQueryKey(options)
});

export const generationModelGetMostLikedArtworksByModelInfiniteQueryKey = (options: Options<GenerationModelGetMostLikedArtworksByModelData>): QueryKey<Options<GenerationModelGetMostLikedArtworksByModelData>> => createQueryKey('generationModelGetMostLikedArtworksByModel', options, true);

/**
 * Get most-liked artworks for a generation model
 *
 * Returns public artworks generated with the given model, ordered by raw all-time `likedCount` descending. Mirrors the GraphQL `artworks(loraId, orderBy: "-markInfo.likedCount")` query the web app uses for the "Most Liked" UI option. Distinct from `/trending`, which uses the `trending1` function-score ranking.
 */
export const generationModelGetMostLikedArtworksByModelInfiniteOptions = (options: Options<GenerationModelGetMostLikedArtworksByModelData>) => infiniteQueryOptions<GenerationModelGetMostLikedArtworksByModelResponse, GenerationModelGetMostLikedArtworksByModelError, InfiniteData<GenerationModelGetMostLikedArtworksByModelResponse>, QueryKey<Options<GenerationModelGetMostLikedArtworksByModelData>>, string | Pick<QueryKey<Options<GenerationModelGetMostLikedArtworksByModelData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GenerationModelGetMostLikedArtworksByModelData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await generationModelGetMostLikedArtworksByModel({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationModelGetMostLikedArtworksByModelInfiniteQueryKey(options)
});

/**
 * Import an external model by URL
 */
export const generationModelImportExternalModelMutation = (options?: Partial<Options<GenerationModelImportExternalModelData>>): UseMutationOptions<GenerationModelImportExternalModelResponse, GenerationModelImportExternalModelError, Options<GenerationModelImportExternalModelData>> => {
    const mutationOptions: UseMutationOptions<GenerationModelImportExternalModelResponse, GenerationModelImportExternalModelError, Options<GenerationModelImportExternalModelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generationModelImportExternalModel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const i18nGetTrackUsageQueryKey = (options: Options<I18nGetTrackUsageData>) => createQueryKey('i18nGetTrackUsage', options, false, ['I18n']);

/**
 * Check whether i18n usage tracking is enabled for the caller
 */
export const i18nGetTrackUsageOptions = (options: Options<I18nGetTrackUsageData>) => queryOptions<I18nGetTrackUsageResponse, DefaultError, I18nGetTrackUsageResponse, ReturnType<typeof i18nGetTrackUsageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await i18nGetTrackUsage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: i18nGetTrackUsageQueryKey(options)
});

/**
 * Report i18n key usage from the frontend
 */
export const i18nPostTrackUsageMutation = (options?: Partial<Options<I18nPostTrackUsageData>>): UseMutationOptions<unknown, DefaultError, Options<I18nPostTrackUsageData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<I18nPostTrackUsageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await i18nPostTrackUsage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create an image generation task
 */
export const imageCreateMutation = (options?: Partial<Options<ImageCreateData>>): UseMutationOptions<ImageCreateResponse, ImageCreateError, Options<ImageCreateData>> => {
    const mutationOptions: UseMutationOptions<ImageCreateResponse, ImageCreateError, Options<ImageCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await imageCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a multimodal reference video task
 */
export const referenceVideoCreateMutation = (options?: Partial<Options<ReferenceVideoCreateData>>): UseMutationOptions<ReferenceVideoCreateResponse, ReferenceVideoCreateError, Options<ReferenceVideoCreateData>> => {
    const mutationOptions: UseMutationOptions<ReferenceVideoCreateResponse, ReferenceVideoCreateError, Options<ReferenceVideoCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await referenceVideoCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a style key ref
 *
 * Saves a style string and returns a short ref ID that can be used in generation parameters.
 */
export const styleKeyRefCreateMutation = (options?: Partial<Options<StyleKeyRefCreateData>>): UseMutationOptions<StyleKeyRefCreateResponse, StyleKeyRefCreateError, Options<StyleKeyRefCreateData>> => {
    const mutationOptions: UseMutationOptions<StyleKeyRefCreateResponse, StyleKeyRefCreateError, Options<StyleKeyRefCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await styleKeyRefCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const referralCampaignSummaryQueryKey = (options?: Options<ReferralCampaignSummaryData>) => createQueryKey('referralCampaignSummary', options, false, ['ReferralCampaign']);

/**
 * Get campaign summary
 *
 * Returns campaign config, inviter eligibility, and invitation counts.
 */
export const referralCampaignSummaryOptions = (options?: Options<ReferralCampaignSummaryData>) => queryOptions<ReferralCampaignSummaryResponse, ReferralCampaignSummaryError, ReferralCampaignSummaryResponse, ReturnType<typeof referralCampaignSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await referralCampaignSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: referralCampaignSummaryQueryKey(options)
});

export const referralCampaignEntriesQueryKey = (options?: Options<ReferralCampaignEntriesData>) => createQueryKey('referralCampaignEntries', options, false, ['ReferralCampaign']);

/**
 * List invitation entries
 *
 * Returns paginated invitation records for the current user as inviter.
 */
export const referralCampaignEntriesOptions = (options?: Options<ReferralCampaignEntriesData>) => queryOptions<ReferralCampaignEntriesResponse, ReferralCampaignEntriesError, ReferralCampaignEntriesResponse, ReturnType<typeof referralCampaignEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await referralCampaignEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: referralCampaignEntriesQueryKey(options)
});

export const referralCampaignEntriesInfiniteQueryKey = (options?: Options<ReferralCampaignEntriesData>): QueryKey<Options<ReferralCampaignEntriesData>> => createQueryKey('referralCampaignEntries', options, true);

/**
 * List invitation entries
 *
 * Returns paginated invitation records for the current user as inviter.
 */
export const referralCampaignEntriesInfiniteOptions = (options?: Options<ReferralCampaignEntriesData>) => infiniteQueryOptions<ReferralCampaignEntriesResponse, ReferralCampaignEntriesError, InfiniteData<ReferralCampaignEntriesResponse>, QueryKey<Options<ReferralCampaignEntriesData>>, string | Pick<QueryKey<Options<ReferralCampaignEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ReferralCampaignEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await referralCampaignEntries({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: referralCampaignEntriesInfiniteQueryKey(options)
});

export const referralCampaignInviteeStatusQueryKey = (options?: Options<ReferralCampaignInviteeStatusData>) => createQueryKey('referralCampaignInviteeStatus', options, false, ['ReferralCampaign']);

/**
 * Get invitee status
 *
 * Returns the current user's qualification status as an invitee, or null.
 */
export const referralCampaignInviteeStatusOptions = (options?: Options<ReferralCampaignInviteeStatusData>) => queryOptions<ReferralCampaignInviteeStatusResponse, ReferralCampaignInviteeStatusError, ReferralCampaignInviteeStatusResponse, ReturnType<typeof referralCampaignInviteeStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await referralCampaignInviteeStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: referralCampaignInviteeStatusQueryKey(options)
});

export const ssrClearExperimentCacheQueryKey = (options?: Options<SsrClearExperimentCacheData>) => createQueryKey('ssrClearExperimentCache', options, false, ['SSR']);

/**
 * Clear SSR experiment cache for the current user
 *
 * Deletes the cached SSR experiment variant for the authenticated user, forcing a fresh lookup on next request.
 */
export const ssrClearExperimentCacheOptions = (options?: Options<SsrClearExperimentCacheData>) => queryOptions<SsrClearExperimentCacheResponse, SsrClearExperimentCacheError, SsrClearExperimentCacheResponse, ReturnType<typeof ssrClearExperimentCacheQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ssrClearExperimentCache({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ssrClearExperimentCacheQueryKey(options)
});

export const tierRewardGetRewardTiersQueryKey = (options: Options<TierRewardGetRewardTiersData>) => createQueryKey('tierRewardGetRewardTiers', options, false, ['Tier Reward']);

/**
 * Get tier reward progress and status
 */
export const tierRewardGetRewardTiersOptions = (options: Options<TierRewardGetRewardTiersData>) => queryOptions<TierRewardGetRewardTiersResponse, TierRewardGetRewardTiersError, TierRewardGetRewardTiersResponse, ReturnType<typeof tierRewardGetRewardTiersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tierRewardGetRewardTiers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tierRewardGetRewardTiersQueryKey(options)
});

/**
 * Claim a single reward tier
 */
export const tierRewardClaimMutation = (options?: Partial<Options<TierRewardClaimData>>): UseMutationOptions<TierRewardClaimResponse, TierRewardClaimError, Options<TierRewardClaimData>> => {
    const mutationOptions: UseMutationOptions<TierRewardClaimResponse, TierRewardClaimError, Options<TierRewardClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tierRewardClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim all available reward tiers
 */
export const tierRewardClaimAllAvailableMutation = (options?: Partial<Options<TierRewardClaimAllAvailableData>>): UseMutationOptions<TierRewardClaimAllAvailableResponse, TierRewardClaimAllAvailableError, Options<TierRewardClaimAllAvailableData>> => {
    const mutationOptions: UseMutationOptions<TierRewardClaimAllAvailableResponse, TierRewardClaimAllAvailableError, Options<TierRewardClaimAllAvailableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tierRewardClaimAllAvailable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset tier reward progress and claims (admin only)
 */
export const tierRewardResetMutation = (options?: Partial<Options<TierRewardResetData>>): UseMutationOptions<unknown, TierRewardResetError, Options<TierRewardResetData>> => {
    const mutationOptions: UseMutationOptions<unknown, TierRewardResetError, Options<TierRewardResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tierRewardReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kaisuukenListQueryKey = (options: Options<KaisuukenListData>) => createQueryKey('kaisuukenList', options, false, ['Kaisuuken']);

/**
 * List kaisuuken cards by IDs for the current user
 */
export const kaisuukenListOptions = (options: Options<KaisuukenListData>) => queryOptions<KaisuukenListResponse, KaisuukenListError, KaisuukenListResponse, ReturnType<typeof kaisuukenListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kaisuukenList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kaisuukenListQueryKey(options)
});

export const kaisuukenSearchQueryKey = (options?: Options<KaisuukenSearchData>) => createQueryKey('kaisuukenSearch', options, false, ['Kaisuuken']);

/**
 * Search kaisuuken cards for the current user with filters and pagination
 */
export const kaisuukenSearchOptions = (options?: Options<KaisuukenSearchData>) => queryOptions<KaisuukenSearchResponse, KaisuukenSearchError, KaisuukenSearchResponse, ReturnType<typeof kaisuukenSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kaisuukenSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kaisuukenSearchQueryKey(options)
});

export const kaisuukenSearchInfiniteQueryKey = (options?: Options<KaisuukenSearchData>): QueryKey<Options<KaisuukenSearchData>> => createQueryKey('kaisuukenSearch', options, true);

/**
 * Search kaisuuken cards for the current user with filters and pagination
 */
export const kaisuukenSearchInfiniteOptions = (options?: Options<KaisuukenSearchData>) => infiniteQueryOptions<KaisuukenSearchResponse, KaisuukenSearchError, InfiniteData<KaisuukenSearchResponse>, QueryKey<Options<KaisuukenSearchData>>, string | Pick<QueryKey<Options<KaisuukenSearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<KaisuukenSearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await kaisuukenSearch({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kaisuukenSearchInfiniteQueryKey(options)
});

export const kaisuukenSummaryQueryKey = (options?: Options<KaisuukenSummaryData>) => createQueryKey('kaisuukenSummary', options, false, ['Kaisuuken']);

/**
 * List summary of kaisuuken for the current user
 */
export const kaisuukenSummaryOptions = (options?: Options<KaisuukenSummaryData>) => queryOptions<KaisuukenSummaryResponse, KaisuukenSummaryError, KaisuukenSummaryResponse, ReturnType<typeof kaisuukenSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kaisuukenSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kaisuukenSummaryQueryKey(options)
});

export const kaisuukenCheckQueryKey = (options: Options<KaisuukenCheckData>) => createQueryKey('kaisuukenCheck', options, false, ['Kaisuuken']);

/**
 * Check which kaisuuken match the given parameters. Returns up to 3 cards per template.
 */
export const kaisuukenCheckOptions = (options: Options<KaisuukenCheckData>) => queryOptions<KaisuukenCheckResponse, KaisuukenCheckError, KaisuukenCheckResponse, ReturnType<typeof kaisuukenCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kaisuukenCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kaisuukenCheckQueryKey(options)
});

export const kaisuukenTemplateListQueryKey = (options: Options<KaisuukenTemplateListData>) => createQueryKey('kaisuukenTemplateList', options, false, ['Kaisuuken']);

/**
 * List kaisuuken templates by IDs
 */
export const kaisuukenTemplateListOptions = (options: Options<KaisuukenTemplateListData>) => queryOptions<KaisuukenTemplateListResponse, DefaultError, KaisuukenTemplateListResponse, ReturnType<typeof kaisuukenTemplateListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kaisuukenTemplateList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kaisuukenTemplateListQueryKey(options)
});

export const kaisuukenLogsQueryKey = (options?: Options<KaisuukenLogsData>) => createQueryKey('kaisuukenLogs', options, false, ['Kaisuuken']);

/**
 * List consume logs for the current user with pagination
 */
export const kaisuukenLogsOptions = (options?: Options<KaisuukenLogsData>) => queryOptions<KaisuukenLogsResponse, KaisuukenLogsError, KaisuukenLogsResponse, ReturnType<typeof kaisuukenLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kaisuukenLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kaisuukenLogsQueryKey(options)
});

export const kaisuukenLogsInfiniteQueryKey = (options?: Options<KaisuukenLogsData>): QueryKey<Options<KaisuukenLogsData>> => createQueryKey('kaisuukenLogs', options, true);

/**
 * List consume logs for the current user with pagination
 */
export const kaisuukenLogsInfiniteOptions = (options?: Options<KaisuukenLogsData>) => infiniteQueryOptions<KaisuukenLogsResponse, KaisuukenLogsError, InfiniteData<KaisuukenLogsResponse>, QueryKey<Options<KaisuukenLogsData>>, string | Pick<QueryKey<Options<KaisuukenLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<KaisuukenLogsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                after: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await kaisuukenLogs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kaisuukenLogsInfiniteQueryKey(options)
});

/**
 * Roll lottery for Spring Promotion 2026
 */
export const lotteryRollMutation = (options?: Partial<Options<LotteryRollData>>): UseMutationOptions<LotteryRollResponse, DefaultError, Options<LotteryRollData>> => {
    const mutationOptions: UseMutationOptions<LotteryRollResponse, DefaultError, Options<LotteryRollData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await lotteryRoll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Purchase lottery tokens
 */
export const lotteryPurchaseTokenMutation = (options?: Partial<Options<LotteryPurchaseTokenData>>): UseMutationOptions<unknown, DefaultError, Options<LotteryPurchaseTokenData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<LotteryPurchaseTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await lotteryPurchaseToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim lottery progress reward
 */
export const lotteryClaimRewardMutation = (options?: Partial<Options<LotteryClaimRewardData>>): UseMutationOptions<LotteryClaimRewardResponse, DefaultError, Options<LotteryClaimRewardData>> => {
    const mutationOptions: UseMutationOptions<LotteryClaimRewardResponse, DefaultError, Options<LotteryClaimRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await lotteryClaimReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset lottery user state (debug/admin)
 */
export const lotteryResetMutation = (options?: Partial<Options<LotteryResetData>>): UseMutationOptions<unknown, DefaultError, Options<LotteryResetData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<LotteryResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await lotteryReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mediaGetMediaInfoQueryKey = (options: Options<MediaGetMediaInfoData>) => createQueryKey('mediaGetMediaInfo', options, false, ['Media']);

/**
 * Get validation-relevant media metadata
 */
export const mediaGetMediaInfoOptions = (options: Options<MediaGetMediaInfoData>) => queryOptions<MediaGetMediaInfoResponse, MediaGetMediaInfoError, MediaGetMediaInfoResponse, ReturnType<typeof mediaGetMediaInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mediaGetMediaInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mediaGetMediaInfoQueryKey(options)
});

/**
 * Generate or get thumbnail media id for a video
 */
export const mediaGetVideoThumbnailIdMutation = (options?: Partial<Options<MediaGetVideoThumbnailIdData>>): UseMutationOptions<MediaGetVideoThumbnailIdResponse, MediaGetVideoThumbnailIdError, Options<MediaGetVideoThumbnailIdData>> => {
    const mutationOptions: UseMutationOptions<MediaGetVideoThumbnailIdResponse, MediaGetVideoThumbnailIdError, Options<MediaGetVideoThumbnailIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mediaGetVideoThumbnailId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get S3 upload url for audio
 */
export const mediaGetAudioUploadUrlMutation = (options?: Partial<Options<MediaGetAudioUploadUrlData>>): UseMutationOptions<MediaGetAudioUploadUrlResponse, MediaGetAudioUploadUrlError, Options<MediaGetAudioUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<MediaGetAudioUploadUrlResponse, MediaGetAudioUploadUrlError, Options<MediaGetAudioUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mediaGetAudioUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get file url for an audio media id
 */
export const mediaGetAudioUrlMutation = (options?: Partial<Options<MediaGetAudioUrlData>>): UseMutationOptions<MediaGetAudioUrlResponse, MediaGetAudioUrlError, Options<MediaGetAudioUrlData>> => {
    const mutationOptions: UseMutationOptions<MediaGetAudioUrlResponse, MediaGetAudioUrlError, Options<MediaGetAudioUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mediaGetAudioUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register uploaded audio by externalId
 */
export const mediaRegisterAudioMutation = (options?: Partial<Options<MediaRegisterAudioData>>): UseMutationOptions<MediaRegisterAudioResponse, MediaRegisterAudioError, Options<MediaRegisterAudioData>> => {
    const mutationOptions: UseMutationOptions<MediaRegisterAudioResponse, MediaRegisterAudioError, Options<MediaRegisterAudioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mediaRegisterAudio({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const oauth2AuthorizeQueryKey = (options: Options<Oauth2AuthorizeData>) => createQueryKey('oauth2Authorize', options, false, ['OAuth2']);

/**
 * OAuth2 authorization request
 *
 * Validate OAuth2 request parameters and return client info for the consent UI. Auth: requires authenticated user session (cookie).
 */
export const oauth2AuthorizeOptions = (options: Options<Oauth2AuthorizeData>) => queryOptions<Oauth2AuthorizeResponse, Oauth2AuthorizeError, Oauth2AuthorizeResponse, ReturnType<typeof oauth2AuthorizeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await oauth2Authorize({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: oauth2AuthorizeQueryKey(options)
});

/**
 * OAuth2 consent decision
 *
 * Record user consent and issue an authorization code if approved. Auth: requires authenticated user session (cookie).
 */
export const oauth2ConsentMutation = (options?: Partial<Options<Oauth2ConsentData>>): UseMutationOptions<Oauth2ConsentResponse, Oauth2ConsentError, Options<Oauth2ConsentData>> => {
    const mutationOptions: UseMutationOptions<Oauth2ConsentResponse, Oauth2ConsentError, Options<Oauth2ConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2Consent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * OAuth2 token exchange
 *
 * Exchange an authorization code for tokens, or refresh an access token. Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).
 */
export const oauth2TokenMutation = (options?: Partial<Options<Oauth2TokenData>>): UseMutationOptions<Oauth2TokenResponse, Oauth2TokenError, Options<Oauth2TokenData>> => {
    const mutationOptions: UseMutationOptions<Oauth2TokenResponse, Oauth2TokenError, Options<Oauth2TokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2Token({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke a token
 *
 * Invalidate an access or refresh token. Always returns 200 per RFC 7009. Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).
 */
export const oauth2RevokeMutation = (options?: Partial<Options<Oauth2RevokeData>>): UseMutationOptions<Oauth2RevokeResponse, Oauth2RevokeError, Options<Oauth2RevokeData>> => {
    const mutationOptions: UseMutationOptions<Oauth2RevokeResponse, Oauth2RevokeError, Options<Oauth2RevokeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2Revoke({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Introspect a token
 *
 * Check whether a token is active and retrieve its metadata. Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).
 */
export const oauth2IntrospectMutation = (options?: Partial<Options<Oauth2IntrospectData>>): UseMutationOptions<Oauth2IntrospectResponse, Oauth2IntrospectError, Options<Oauth2IntrospectData>> => {
    const mutationOptions: UseMutationOptions<Oauth2IntrospectResponse, Oauth2IntrospectError, Options<Oauth2IntrospectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2Introspect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const oauth2ServerMetadataQueryKey = (options: Options<Oauth2ServerMetadataData>) => createQueryKey('oauth2ServerMetadata', options, false, ['OAuth2']);

/**
 * OAuth2 server metadata
 *
 * OAuth2 server configuration and endpoint discovery. Auth: none (public).
 */
export const oauth2ServerMetadataOptions = (options: Options<Oauth2ServerMetadataData>) => queryOptions<Oauth2ServerMetadataResponse, DefaultError, Oauth2ServerMetadataResponse, ReturnType<typeof oauth2ServerMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await oauth2ServerMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: oauth2ServerMetadataQueryKey(options)
});

/**
 * OAuth2 device authorization request
 *
 * Request a device code and user code for the device authorization flow (RFC 8628). Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).
 */
export const oauth2DeviceAuthorizationMutation = (options?: Partial<Options<Oauth2DeviceAuthorizationData>>): UseMutationOptions<Oauth2DeviceAuthorizationResponse, Oauth2DeviceAuthorizationError, Options<Oauth2DeviceAuthorizationData>> => {
    const mutationOptions: UseMutationOptions<Oauth2DeviceAuthorizationResponse, Oauth2DeviceAuthorizationError, Options<Oauth2DeviceAuthorizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2DeviceAuthorization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify a device user code
 *
 * Look up a device authorization request by user_code and return application info. Auth: requires authenticated user session (cookie).
 */
export const oauth2DeviceVerifyMutation = (options?: Partial<Options<Oauth2DeviceVerifyData>>): UseMutationOptions<Oauth2DeviceVerifyResponse, Oauth2DeviceVerifyError, Options<Oauth2DeviceVerifyData>> => {
    const mutationOptions: UseMutationOptions<Oauth2DeviceVerifyResponse, Oauth2DeviceVerifyError, Options<Oauth2DeviceVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2DeviceVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve or deny a device authorization
 *
 * Record user consent decision for a device code. Auth: requires authenticated user session (cookie).
 */
export const oauth2DeviceConsentMutation = (options?: Partial<Options<Oauth2DeviceConsentData>>): UseMutationOptions<Oauth2DeviceConsentResponse, Oauth2DeviceConsentError, Options<Oauth2DeviceConsentData>> => {
    const mutationOptions: UseMutationOptions<Oauth2DeviceConsentResponse, Oauth2DeviceConsentError, Options<Oauth2DeviceConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2DeviceConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const oauth2ClientStartQueryKey = (options: Options<Oauth2ClientStartData>) => createQueryKey('oauth2ClientStart', options, false, ['OAuth2 Client']);

/**
 * Initiate OAuth flow with the named provider (302 to provider). Top-level navigation so the pre-auth cookie is set in a first-party context. `clientType` distinguishes web vs mobile in-app browser.
 */
export const oauth2ClientStartOptions = (options: Options<Oauth2ClientStartData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof oauth2ClientStartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await oauth2ClientStart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: oauth2ClientStartQueryKey(options)
});

export const oauth2ClientCallbackQueryKey = (options: Options<Oauth2ClientCallbackData>) => createQueryKey('oauth2ClientCallback', options, false, ['OAuth2 Client']);

/**
 * Provider callback. 302 to record.redirectUrl on success, 302 to ${appBaseUrl}/auth/error?code=… on failure.
 */
export const oauth2ClientCallbackOptions = (options: Options<Oauth2ClientCallbackData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof oauth2ClientCallbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await oauth2ClientCallback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: oauth2ClientCallbackQueryKey(options)
});

/**
 * Apple form-post callback variant (apple, apple2)
 */
export const oauth2ClientAppleCallbackMutation = (options?: Partial<Options<Oauth2ClientAppleCallbackData>>): UseMutationOptions<unknown, DefaultError, Options<Oauth2ClientAppleCallbackData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<Oauth2ClientAppleCallbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2ClientAppleCallback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Exchange a native-SDK id_token for a session JWT
 */
export const oauth2ClientNativeMutation = (options?: Partial<Options<Oauth2ClientNativeData>>): UseMutationOptions<Oauth2ClientNativeResponse, DefaultError, Options<Oauth2ClientNativeData>> => {
    const mutationOptions: UseMutationOptions<Oauth2ClientNativeResponse, DefaultError, Options<Oauth2ClientNativeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2ClientNative({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Redeem a single-use exchange code for a session JWT. Requires X-Device-Id matching the deviceId supplied at /start.
 */
export const oauth2ClientExchangeMutation = (options?: Partial<Options<Oauth2ClientExchangeData>>): UseMutationOptions<Oauth2ClientExchangeResponse, DefaultError, Options<Oauth2ClientExchangeData>> => {
    const mutationOptions: UseMutationOptions<Oauth2ClientExchangeResponse, DefaultError, Options<Oauth2ClientExchangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oauth2ClientExchange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Exchange pixai credits for a kotone credit pack
 */
export const kotoneCreditExchangeCreditPackMutation = (options?: Partial<Options<KotoneCreditExchangeCreditPackData>>): UseMutationOptions<KotoneCreditExchangeCreditPackResponse, KotoneCreditExchangeCreditPackError, Options<KotoneCreditExchangeCreditPackData>> => {
    const mutationOptions: UseMutationOptions<KotoneCreditExchangeCreditPackResponse, KotoneCreditExchangeCreditPackError, Options<KotoneCreditExchangeCreditPackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kotoneCreditExchangeCreditPack({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim monthly membership kotone credit pack
 */
export const kotoneCreditClaimMonthlyMembershipCreditPackMutation = (options?: Partial<Options<KotoneCreditClaimMonthlyMembershipCreditPackData>>): UseMutationOptions<KotoneCreditClaimMonthlyMembershipCreditPackResponse, KotoneCreditClaimMonthlyMembershipCreditPackError, Options<KotoneCreditClaimMonthlyMembershipCreditPackData>> => {
    const mutationOptions: UseMutationOptions<KotoneCreditClaimMonthlyMembershipCreditPackResponse, KotoneCreditClaimMonthlyMembershipCreditPackError, Options<KotoneCreditClaimMonthlyMembershipCreditPackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kotoneCreditClaimMonthlyMembershipCreditPack({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kotoneCreditGetMonthlyMembershipGrantStatusQueryKey = (options?: Options<KotoneCreditGetMonthlyMembershipGrantStatusData>) => createQueryKey('kotoneCreditGetMonthlyMembershipGrantStatus', options, false, ['Kotone']);

/**
 * Get monthly membership credit pack grant status
 */
export const kotoneCreditGetMonthlyMembershipGrantStatusOptions = (options?: Options<KotoneCreditGetMonthlyMembershipGrantStatusData>) => queryOptions<KotoneCreditGetMonthlyMembershipGrantStatusResponse, DefaultError, KotoneCreditGetMonthlyMembershipGrantStatusResponse, ReturnType<typeof kotoneCreditGetMonthlyMembershipGrantStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kotoneCreditGetMonthlyMembershipGrantStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kotoneCreditGetMonthlyMembershipGrantStatusQueryKey(options)
});

/**
 * Create a one-time purchase order for Kotone
 */
export const kotoneOrderCreateMutation = (options?: Partial<Options<KotoneOrderCreateData>>): UseMutationOptions<KotoneOrderCreateResponse, KotoneOrderCreateError, Options<KotoneOrderCreateData>> => {
    const mutationOptions: UseMutationOptions<KotoneOrderCreateResponse, KotoneOrderCreateError, Options<KotoneOrderCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kotoneOrderCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kotoneOrderGetQueryKey = (options: Options<KotoneOrderGetData>) => createQueryKey('kotoneOrderGet', options, false, ['KotoneOrder']);

/**
 * Get Kotone order by ID
 */
export const kotoneOrderGetOptions = (options: Options<KotoneOrderGetData>) => queryOptions<KotoneOrderGetResponse, KotoneOrderGetError, KotoneOrderGetResponse, ReturnType<typeof kotoneOrderGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kotoneOrderGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kotoneOrderGetQueryKey(options)
});

/**
 * Cancel a Kotone order
 */
export const kotoneOrderCancelMutation = (options?: Partial<Options<KotoneOrderCancelData>>): UseMutationOptions<unknown, KotoneOrderCancelError, Options<KotoneOrderCancelData>> => {
    const mutationOptions: UseMutationOptions<unknown, KotoneOrderCancelError, Options<KotoneOrderCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kotoneOrderCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark a Kotone order as completed (Agent confirms fulfillment)
 */
export const kotoneOrderCompleteMutation = (options?: Partial<Options<KotoneOrderCompleteData>>): UseMutationOptions<unknown, KotoneOrderCompleteError, Options<KotoneOrderCompleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, KotoneOrderCompleteError, Options<KotoneOrderCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kotoneOrderComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark a Kotone order as refunded (Agent confirms benefit revocation)
 */
export const kotoneOrderConfirmRefundMutation = (options?: Partial<Options<KotoneOrderConfirmRefundData>>): UseMutationOptions<unknown, KotoneOrderConfirmRefundError, Options<KotoneOrderConfirmRefundData>> => {
    const mutationOptions: UseMutationOptions<unknown, KotoneOrderConfirmRefundError, Options<KotoneOrderConfirmRefundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kotoneOrderConfirmRefund({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contentSafetyPreferenceGetContentSafetyPreferencesQueryKey = (options?: Options<ContentSafetyPreferenceGetContentSafetyPreferencesData>) => createQueryKey('contentSafetyPreferenceGetContentSafetyPreferences', options, false, ['Content Safety Preference']);

/**
 * Get content safety preferences for current user
 */
export const contentSafetyPreferenceGetContentSafetyPreferencesOptions = (options?: Options<ContentSafetyPreferenceGetContentSafetyPreferencesData>) => queryOptions<ContentSafetyPreferenceGetContentSafetyPreferencesResponse, ContentSafetyPreferenceGetContentSafetyPreferencesError, ContentSafetyPreferenceGetContentSafetyPreferencesResponse, ReturnType<typeof contentSafetyPreferenceGetContentSafetyPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentSafetyPreferenceGetContentSafetyPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentSafetyPreferenceGetContentSafetyPreferencesQueryKey(options)
});

/**
 * Update a content safety preference
 */
export const contentSafetyPreferenceUpdateContentSafetyPreferenceMutation = (options?: Partial<Options<ContentSafetyPreferenceUpdateContentSafetyPreferenceData>>): UseMutationOptions<ContentSafetyPreferenceUpdateContentSafetyPreferenceResponse, ContentSafetyPreferenceUpdateContentSafetyPreferenceError, Options<ContentSafetyPreferenceUpdateContentSafetyPreferenceData>> => {
    const mutationOptions: UseMutationOptions<ContentSafetyPreferenceUpdateContentSafetyPreferenceResponse, ContentSafetyPreferenceUpdateContentSafetyPreferenceError, Options<ContentSafetyPreferenceUpdateContentSafetyPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentSafetyPreferenceUpdateContentSafetyPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a credit exchange transaction (partner-facing)
 */
export const creditExchangeCreateTransactionMutation = (options?: Partial<Options<CreditExchangeCreateTransactionData>>): UseMutationOptions<CreditExchangeCreateTransactionResponse, CreditExchangeCreateTransactionError, Options<CreditExchangeCreateTransactionData>> => {
    const mutationOptions: UseMutationOptions<CreditExchangeCreateTransactionResponse, CreditExchangeCreateTransactionError, Options<CreditExchangeCreateTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await creditExchangeCreateTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const creditExchangeExternalTokenStatusQueryKey = (options: Options<CreditExchangeExternalTokenStatusData>) => createQueryKey('creditExchangeExternalTokenStatus', options, false, ['CreditExchange']);

/**
 * Check redeem token status (partner-facing, S2S)
 */
export const creditExchangeExternalTokenStatusOptions = (options: Options<CreditExchangeExternalTokenStatusData>) => queryOptions<CreditExchangeExternalTokenStatusResponse, CreditExchangeExternalTokenStatusError, CreditExchangeExternalTokenStatusResponse, ReturnType<typeof creditExchangeExternalTokenStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await creditExchangeExternalTokenStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: creditExchangeExternalTokenStatusQueryKey(options)
});

export const creditExchangeTokenSummaryQueryKey = (options: Options<CreditExchangeTokenSummaryData>) => createQueryKey('creditExchangeTokenSummary', options, false, ['CreditExchange']);

/**
 * Get redeem token summary (user-facing)
 */
export const creditExchangeTokenSummaryOptions = (options: Options<CreditExchangeTokenSummaryData>) => queryOptions<CreditExchangeTokenSummaryResponse, CreditExchangeTokenSummaryError, CreditExchangeTokenSummaryResponse, ReturnType<typeof creditExchangeTokenSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await creditExchangeTokenSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: creditExchangeTokenSummaryQueryKey(options)
});

/**
 * Redeem a credit exchange token (user-facing)
 */
export const creditExchangeRedeemTokenMutation = (options?: Partial<Options<CreditExchangeRedeemTokenData>>): UseMutationOptions<CreditExchangeRedeemTokenResponse, CreditExchangeRedeemTokenError, Options<CreditExchangeRedeemTokenData>> => {
    const mutationOptions: UseMutationOptions<CreditExchangeRedeemTokenResponse, CreditExchangeRedeemTokenError, Options<CreditExchangeRedeemTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await creditExchangeRedeemToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const decorationBatchQueryKey = (options: Options<DecorationBatchData>) => createQueryKey('decorationBatch', options, false, ['Decoration']);

/**
 * Batch get decorations by IDs
 *
 * Returns decorations matching the given IDs, ordered to match the input `ids`. Unknown IDs are silently omitted. Capped at 50 IDs per request.
 */
export const decorationBatchOptions = (options: Options<DecorationBatchData>) => queryOptions<DecorationBatchResponse, DefaultError, DecorationBatchResponse, ReturnType<typeof decorationBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await decorationBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: decorationBatchQueryKey(options)
});

export const decorationGetDecorationQueryKey = (options: Options<DecorationGetDecorationData>) => createQueryKey('decorationGetDecoration', options, false, ['Decoration']);

/**
 * Get decoration by ID
 */
export const decorationGetDecorationOptions = (options: Options<DecorationGetDecorationData>) => queryOptions<DecorationGetDecorationResponse, DecorationGetDecorationError, DecorationGetDecorationResponse, ReturnType<typeof decorationGetDecorationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await decorationGetDecoration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: decorationGetDecorationQueryKey(options)
});

/**
 * Create an image generation task on behalf of a user
 */
export const internalImageCreateMutation = (options?: Partial<Options<InternalImageCreateData>>): UseMutationOptions<InternalImageCreateResponse, InternalImageCreateError, Options<InternalImageCreateData>> => {
    const mutationOptions: UseMutationOptions<InternalImageCreateResponse, InternalImageCreateError, Options<InternalImageCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalImageCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bind two existing users as inviter/invitee in the referral system
 */
export const internalReferralBindMutation = (options?: Partial<Options<InternalReferralBindData>>): UseMutationOptions<InternalReferralBindResponse, InternalReferralBindError, Options<InternalReferralBindData>> => {
    const mutationOptions: UseMutationOptions<InternalReferralBindResponse, InternalReferralBindError, Options<InternalReferralBindData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalReferralBind({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const internalTaskGetByIdQueryKey = (options: Options<InternalTaskGetByIdData>) => createQueryKey('internalTaskGetById', options, false, ['InternalTask']);

/**
 * Get a task by ID (bypasses ownership check)
 *
 * Returns the current status and outputs of any task. Internal callers are trusted and skip user ownership verification. When `min_safety_score` is provided, `outputs` is blanked to an empty object ONLY when the task image has been moderated and its persisted safety score is below the threshold (known-unsafe). Tasks whose safety score is missing or still pending are returned as-is — callers that need a meaningful gate must opt their task into moderation at creation time (`moderationPolicy: "force"` on `/internal/task/image/create`).
 */
export const internalTaskGetByIdOptions = (options: Options<InternalTaskGetByIdData>) => queryOptions<InternalTaskGetByIdResponse, InternalTaskGetByIdError, InternalTaskGetByIdResponse, ReturnType<typeof internalTaskGetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await internalTaskGetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: internalTaskGetByIdQueryKey(options)
});

export const internalTaskGetModerationQueryKey = (options: Options<InternalTaskGetModerationData>) => createQueryKey('internalTaskGetModeration', options, false, ['InternalTask']);

/**
 * Get the moderation result of a task
 *
 * Returns safety scores for the task prompt and generated image. Returns `{ result: "not_ready" }` with HTTP 200 when the image moderation has not completed yet — the caller should keep polling. Returns 404 when the task does not exist.
 */
export const internalTaskGetModerationOptions = (options: Options<InternalTaskGetModerationData>) => queryOptions<InternalTaskGetModerationResponse, InternalTaskGetModerationError, InternalTaskGetModerationResponse, ReturnType<typeof internalTaskGetModerationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await internalTaskGetModeration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: internalTaskGetModerationQueryKey(options)
});

/**
 * Create a chat-based image editing task on behalf of a user
 *
 * Creates a chat editing task for the specified user. Supports billing override, custom priority, and content moderation scene.
 */
export const internalTaskEditCreateMutation = (options?: Partial<Options<InternalTaskEditCreateData>>): UseMutationOptions<InternalTaskEditCreateResponse, InternalTaskEditCreateError, Options<InternalTaskEditCreateData>> => {
    const mutationOptions: UseMutationOptions<InternalTaskEditCreateResponse, InternalTaskEditCreateError, Options<InternalTaskEditCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalTaskEditCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bind a PixAI user to an external account (idempotent + strict)
 *
 * Internal-only. Trusted by Rubert: assumes the external identity has already been verified upstream. Returns 201 when a new binding is created, 200 when an exact match already existed. Conflicts surface as structured 4xx errors. If `email` is provided, may also update the user's email/verified state per the design spec.
 */
export const internalUserExternalProfilesBindMutation = (options?: Partial<Options<InternalUserExternalProfilesBindData>>): UseMutationOptions<InternalUserExternalProfilesBindResponse, InternalUserExternalProfilesBindError, Options<InternalUserExternalProfilesBindData>> => {
    const mutationOptions: UseMutationOptions<InternalUserExternalProfilesBindResponse, InternalUserExternalProfilesBindError, Options<InternalUserExternalProfilesBindData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalUserExternalProfilesBind({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const internalUserExternalProfilesListByUserIdQueryKey = (options: Options<InternalUserExternalProfilesListByUserIdData>) => createQueryKey('internalUserExternalProfilesListByUserId', options, false, ['InternalUserExternalProfiles']);

/**
 * List a user's external profiles (optional provider filter)
 */
export const internalUserExternalProfilesListByUserIdOptions = (options: Options<InternalUserExternalProfilesListByUserIdData>) => queryOptions<InternalUserExternalProfilesListByUserIdResponse, InternalUserExternalProfilesListByUserIdError, InternalUserExternalProfilesListByUserIdResponse, ReturnType<typeof internalUserExternalProfilesListByUserIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await internalUserExternalProfilesListByUserId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: internalUserExternalProfilesListByUserIdQueryKey(options)
});

export const footprintListPreferencesQueryKey = (options: Options<FootprintListPreferencesData>) => createQueryKey('footprintListPreferences', options, false, ['Footprint']);

/**
 * List footprint preferences for a user
 *
 * Returns the top 50 most-recently-updated preference entries from the user's footprint namespace, sorted by `lastUpdatedAt` descending. The set of preference sub-types is bounded by design, so 50 is well beyond what any user can accumulate and no pagination is exposed. Pass `?keys=a,b` to restrict the response to a subset of sub-types. Accessible only to the user themselves or to admins. Responds 404 when the user's namespace has never been written to, and `[]` when the namespace exists but contains no preference entries.
 */
export const footprintListPreferencesOptions = (options: Options<FootprintListPreferencesData>) => queryOptions<FootprintListPreferencesResponse, FootprintListPreferencesError, FootprintListPreferencesResponse, ReturnType<typeof footprintListPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await footprintListPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: footprintListPreferencesQueryKey(options)
});

export const footprintListActionsQueryKey = (options: Options<FootprintListActionsData>) => createQueryKey('footprintListActions', options, false, ['Footprint']);

/**
 * List footprint actions for a user
 *
 * Returns the user's recorded action entries (likes, dislikes, publishes) sorted by `lastUpdatedAt` descending. Pass `?subTypes=a,b` to restrict to a subset, `?limit=N` (1–100, default 50) to control page size, and `?cursor=...` to fetch the next page using the `nextCursor` returned by the previous call. The `source` field (api_sync / cron_job / agent) is included only for admin requesters. Note: rows whose `lastUpdatedAt` is exactly equal at the cursor boundary may be skipped — millisecond collisions are rare in practice. Accessible only to the user themselves or to admins. Responds 404 when the namespace has never been written to, and an empty `entries` array when it exists but contains no matching action entries.
 */
export const footprintListActionsOptions = (options: Options<FootprintListActionsData>) => queryOptions<FootprintListActionsResponse, FootprintListActionsError, FootprintListActionsResponse, ReturnType<typeof footprintListActionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await footprintListActions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: footprintListActionsQueryKey(options)
});

export const footprintListActionsInfiniteQueryKey = (options: Options<FootprintListActionsData>): QueryKey<Options<FootprintListActionsData>> => createQueryKey('footprintListActions', options, true);

/**
 * List footprint actions for a user
 *
 * Returns the user's recorded action entries (likes, dislikes, publishes) sorted by `lastUpdatedAt` descending. Pass `?subTypes=a,b` to restrict to a subset, `?limit=N` (1–100, default 50) to control page size, and `?cursor=...` to fetch the next page using the `nextCursor` returned by the previous call. The `source` field (api_sync / cron_job / agent) is included only for admin requesters. Note: rows whose `lastUpdatedAt` is exactly equal at the cursor boundary may be skipped — millisecond collisions are rare in practice. Accessible only to the user themselves or to admins. Responds 404 when the namespace has never been written to, and an empty `entries` array when it exists but contains no matching action entries.
 */
export const footprintListActionsInfiniteOptions = (options: Options<FootprintListActionsData>) => infiniteQueryOptions<FootprintListActionsResponse, FootprintListActionsError, InfiniteData<FootprintListActionsResponse>, QueryKey<Options<FootprintListActionsData>>, string | Pick<QueryKey<Options<FootprintListActionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FootprintListActionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await footprintListActions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: footprintListActionsInfiniteQueryKey(options)
});

export const notificationPreferenceGetNotificationPreferenceQueryKey = (options?: Options<NotificationPreferenceGetNotificationPreferenceData>) => createQueryKey('notificationPreferenceGetNotificationPreference', options, false, ['UserNotificationPreference']);

/**
 * Get push notification preferences for the current user
 */
export const notificationPreferenceGetNotificationPreferenceOptions = (options?: Options<NotificationPreferenceGetNotificationPreferenceData>) => queryOptions<NotificationPreferenceGetNotificationPreferenceResponse, NotificationPreferenceGetNotificationPreferenceError, NotificationPreferenceGetNotificationPreferenceResponse, ReturnType<typeof notificationPreferenceGetNotificationPreferenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notificationPreferenceGetNotificationPreference({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: notificationPreferenceGetNotificationPreferenceQueryKey(options)
});

/**
 * Update push notification preferences for the current user
 */
export const notificationPreferenceSetNotificationPreferenceMutation = (options?: Partial<Options<NotificationPreferenceSetNotificationPreferenceData>>): UseMutationOptions<NotificationPreferenceSetNotificationPreferenceResponse, NotificationPreferenceSetNotificationPreferenceError, Options<NotificationPreferenceSetNotificationPreferenceData>> => {
    const mutationOptions: UseMutationOptions<NotificationPreferenceSetNotificationPreferenceResponse, NotificationPreferenceSetNotificationPreferenceError, Options<NotificationPreferenceSetNotificationPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationPreferenceSetNotificationPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
